import { CaretRightOutlined, UpCircleOutlined } from '@ant-design/icons';
import { Card, Collapse } from 'antd';
import imagePVI from 'assets/images/imagePVI.png';
import imagePVI1 from 'assets/images/imagePVI_1.png';
import imagePVI2 from 'assets/images/imagePVI_2.png';
import imagePVI3 from 'assets/images/imagepvi_3.png';
import BgrContainer from 'assets/images/istock-1140524580_3.jpg';
import PVI_Insurance_card from 'assets/images/PVI_Insurance_card.jpg';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const { Panel } = Collapse;

const PageXclaimInsurance = () => {
  const { t } = useTranslation(['PTIManagement']);
  const pdfUrl = '/HDSD_app_My_PVI.pdf';

  // Updated for 2025-2026 PVI Health Insurance Program
  // Key changes: Updated waiting periods, benefit amounts, and coverage terms
  //
  // CHANGES MADE FOR 2025-2026:
  // 1. Updated eligibility exclusions to include "ung thư" (cancer)
  // 2. Updated waiting period rules for 2024 contract participants
  // 3. Added accident coverage to waiting period tables
  // 4. Combined general treatment and dental treatment for employees
  // 5. Updated accident insurance table (Part 1) with new benefit amounts (50M/30M)
  // 6. Updated death/permanent disability table (Part 2) with new benefit amounts
  // 7. Updated outpatient treatment and dental care table (Part 2B) with new benefit amounts
  // 8. Updated notes section with new dental treatment requirements for different regions
  // 9. Updated hospital guarantee list with new information for Hanoi and Ho Chi Minh City
  // 10. Commented out Program 2 columns across all tables (only Program 1 available)
  // 11. Maintained original format structure but removed Program 2 data
  // 12. Added comprehensive comments to track changes

  const [showsScrolBtn, setShowScrolBtn] = useState(false);

  useEffect(() => {
    const handleButtonVisibility = () => {
      window.pageYOffset > 300 ? setShowScrolBtn(true) : setShowScrolBtn(false);
    };

    window.addEventListener('scroll', handleButtonVisibility);
    return () => {
      window.addEventListener('scroll', handleButtonVisibility);
    };
  }, []);

  // UPDATED 2025-2026: Eligibility conditions for health insurance participation
  const dieuKienThamGiaBH = [
    {
      title: '1. ĐỐI TƯỢNG ĐƯỢC BẢO HIỂM:',
      list: [
        {
          text: 'Cán bộ công nhân viên',
        },
        {
          text: 'Độ tuổi tham gia bảo hiểm: Từ đủ 18 tuổi đến hết 65 tuổi.',
        },
        {
          text: 'Người Việt Nam hoặc người nước ngoài sinh sống và làm việc trong lãnh thổ Việt Nam và không rời Việt Nam quá 180 ngày liên tục',
        },
      ],
    },
    {
      title: '2. KHÔNG BẢO HIỂM:',
      list: [
        {
          text: 'Người bị mắc bệnh tâm thần, động kinh, ung thư..', // UPDATED 2025-2026: Added "ung thư" to exclusions
        },
        {
          text: 'Bị thương tật vĩnh viễn từ 80% trở lên tại thời điểm hiệu lực Hợp đồng',
        },
      ],
    },
  ];

  const quyenLoiBaoHiem = [
    {
      title: 'Tử vong,tàn tật toàn bộ vĩnh viễn do ốm đau, bệnh tật, thai sản',
      list: [
        {
          text: 'Tử vong do ốm đau, bệnh tật, thai sản',
        },
        {
          text: 'Tàn tật toàn bộ vĩnh viễn do ốm đau, bệnh tật, thai sản',
        },
      ],
    },
    {
      title: 'Tai nạn 24/24',
      list: [
        {
          text: 'Chết, thương tật toàn bộ vĩnh viễn do tai nạn',
        },
        {
          text: 'Thương tật bộ phận vĩnh viễn do tai nạn',
        },
        {
          text: 'Chi phí y tế do tai nạn',
        },
      ],
    },
    {
      title: 'Chi phí y tế do bệnh tật',
      list: [
        {
          text: 'Nằm viện, phẫu thuật, thai sản',
        },
        {
          text: 'Điều trị ngoại trú',
        },
        {
          text: 'Điều trị răng (bao gồm trong điều trị ngoại trú)',
        },
      ],
    },
  ];
  const loaiTruChung = [
    'Cai nghiện ma túy, cai nghiện rượu, sử dụng thuốc không theo chỉ định của Cơ sở y tế/ Bác sĩ',
    'Bất kỳ ốm đau, bệnh tật, thương tích hay chết nào gây ra bởi chiến tranh, nội chiến, đình công, khủng bố',
    'Hành động cố ý của NĐBH hoặc người thừa kế hợp pháp',
    'NĐBH có ý định tự tử hoặc cố ý dấn thân vào nơi nguy hiểm không cần thiết trừ khi có ý định cứu người, cứu tài sản',
    'Thương tật của Người được bảo hiểm phát sinh từ đánh lộn trừ phi chứng minh được đó là do phải bảo vệ tính mạng của bản thân',
    'Vi phạm nghiêm trọng pháp luật',
    'Người được bảo hiểm bị ảnh hưởng của rượu, bia, ma tuý hoặc các chất kích thích tương tự khác',
    'Điều trị tất cả các loại bệnh tâm thần hoặc rối loạn tâm thần',
    'Điều trị liên quan đến các bệnh lây lan qua đường tình dục (lậu, giang mai…), HIV',
    'Bất kỳ ốm đau, bệnh tật, thương tích hay chết nào phát sinh trực tiếp hoặc gián tiếp từ ô nhiễm hoá học, chất phóng xạ,nguyên liệu hạt nhân hay thiên tai như: động đất, núi lửa gây ra',
    'Điều trị phục hồi chức năng, duy trì hay chỉnh sửa các bộ phận hoặc dụng cụ giả được lắp đặt từ bên ngoài, các bộ phận giả, răng giả, nạng chống, xe đẩy…',
  ];

  // UPDATED 2025-2026: Accident Insurance Table (Part 1) - Correct format with 3 columns
  const baoHiemTaiNan = [
    {
      stt: '1',
      name1: 'Tử vong / Thương tật vĩnh viễn / Mất tích do tai nạn',
      name2: '',
      name3: '50.000.000',
    },
    {
      stt: '',
      name1: 'Tử vong / Thương tật toàn bộ vĩnh viễn / Mất tích',
      name2: '100% Số tiền bảo hiểm',
      name3: '',
    },
    {
      stt: '',
      name1: 'Thương tật bộ phận vĩnh viễn',
      name2:
        'Bồi thường theo tỷ lệ phần trăm trên Số tiền bảo hiểm theo Bảng tỷ lệ trả tiền bảo hiểm thương tật',
      name3: '',
    },
    {
      stt: '2',
      name1: 'Chi phí y tế do tai nạn (Giới hạn lãnh thổ: Việt Nam)',
      name2: '',
      name3: '30.000.000',
    },
    {
      stt: '',
      name1:
        'Chi phí y tế phát sinh do điều trị thương tật thân thể theo chỉ định của bác sĩ điều trị (bao gồm chi phí vận chuyển cấp cứu, loại trừ bằng đường hàng không)',
      name2:
        'Bồi thường chi phí y tế thực tế và hợp lý tối đa đến Số tiền bảo hiểm của quyền lợi này',
      name3: '',
    },
  ];

  const loaiTruTuVongBenhVaThaiSan = [
    '1. Tự tử',
    '2. HIV/AIDS',
    '3. Thực hiện hoặc mưu toan hành vi phạm tội',
  ];

  // UPDATED 2025-2026: Death/Permanent Total Disability due to Illness, Sickness, Maternity
  const baoHiemTuVong = [
    {
      stt: '',
      name1: 'Giới hạn lãnh thổ',
      name2: 'Việt Nam',
      // name3: 'Việt Nam', // COMMENTED OUT: Only Program 1 available for 2025-2026
    },
    {
      stt: '1',
      name1: 'Tử vong hoặc tàn tật toàn bộ vĩnh viễn do ốm đau, bệnh tật, thai sản',
      name2: '50.000.000',
      // name3: '50.000.000', // COMMENTED OUT: Only Program 1 available for 2025-2026
    },
  ];

  // UPDATED 2025-2026: Updated medical cost insurance table to show only Program 1
  const baoHiemChiPhiYTe = [
    { stt: '', name1: 'Giới hạn Lãnh thổ', name2: 'Việt Nam' },
    {
      stt: '',
      name1: 'Giới hạn tối đa/Người/Năm (Giới hạn chung, bao gồm các giới hạn phụ dưới đây)',
      name2: '150.000.000',
    },
    {
      stt: '1',
      name1: (
        <>
          <p>
            Viện phí (chi phí y tế cần thiết và hợp lý cung cấp bởi bệnh viện trong quá trình nằm
            viện) bao gồm nhưng không giới hạn:
          </p>
          <p>
            • Tiền giường điều trị tại phòng đơn tiêu chuẩn, suất ăn theo tiêu chuẩn tại bệnh viện
          </p>
          <p>• Chi phí phòng chăm sóc đặc biệt</p>
          <p>• Chi phí hành chính, chi phí máu, huyết tương</p>
          <p>• Thuốc sử dụng trong khi nằm viện</p>
          <p>
            • Vật lý trị liệu (nếu những chi phí này là cần thiết trong quá trình nằm viện theo chỉ
            định của bác sĩ)
          </p>
          <p>• Tiêm truyền tĩnh mạch</p>
          <p>
            • Xét nghiệm hoặc chẩn đoán hình ảnh như X-quang, MRI, CT, PET... do Bác sĩ chỉ định và
            phải là một phần của chi phí điều trị nằm viện
          </p>
          <p>• Vật tư y tế, vật tư tiêu hao</p>
        </>
      ),
      name2: (
        <>
          <p>2.500.000/ngày</p>
          <p>Tối đa không quá 50.000.000/năm</p>
        </>
      ),
    },
    {
      stt: '2',
      name1: (
        <>
          <p>
            Chi phí phẫu thuật (chi phí cần thiết và hợp lý liên quan đến một ca phẫu thuật nội trú,
            phẫu thuật trong ngày hoặc phẫu thuật ngoại trú) bao gồm nhưng không giới hạn:
          </p>
          <p>• Chi phí phòng mổ</p>
          <p>• Phẫu thuật viên</p>
          <p>• Chi phí gây mê</p>
          <p>• Các dụng cụ, thiết bị phẫu thuật</p>
          <p>• Thuốc dùng trong phẫu thuật</p>
          <p>• Vật tư y tế</p>
          <p>• Chi phí hồi sức sau khi mổ</p>
          <p>
            • Chi phí cấy ghép nội tạng (không bao gồm chi phí mua, vận chuyển cơ quan nội tạng cấy
            ghép và toàn bộ các chi phí phát sinh cho người hiến bộ phận cơ thể)
          </p>
          <p>• Chi phí tái mổ</p>
        </>
      ),
      name2: 'Tối đa không quá 50.000.000/năm',
    },
    {
      stt: '3',
      name1: 'Điều trị cấp cứu (bao gồm điều trị nội trú, trong ngày hoặc ngoại trú)',
      name2: 'Tối đa không quá 50.000.000/năm',
    },
    {
      stt: '4',
      name1: 'Chi phí trước Nhập viện (Trong vòng 30 ngày trước khi nhập viện)',
      name2: '2.500.000/năm',
    },
    {
      stt: '5',
      name1: 'Điều trị sau khi Xuất viện (Trong vòng 30 ngày trước khi xuất viện)',
      name2: '2.500.000/năm',
    },
    {
      stt: '6',
      name1: 'Chi phí y tá chăm sóc tại nhà ngay sau khi xuất viện (Tối đa 30 ngày/năm)',
      name2: '2.500.000/năm',
    },
    {
      stt: '7',
      name1:
        'Vận chuyển cấp cứu (Trong trường hợp không có dịch vụ cứu thương của địa phương, Người được bảo hiểm có thể dùng taxi với giới hạn trách nhiệm tới 200.000VNĐ/vụ. Hóa đơn taxi phải được cung cấp với thông tin liên quan)',
      name2: 'Tối đa không quá 50.000.000/năm',
    },
    {
      stt: '8',
      name1: 'Trợ cấp nằm viện/ ngày (Tối đa 60 ngày/năm)',
      name2: '50.000/ngày',
    },
    {
      stt: '9',
      name1:
        'Trợ cấp mai táng (Chỉ áp dụng trong trường hợp tử vong tại bệnh viện với điều kiện có chi phí y tế phát sinh trước khi tử vong)',
      name2: '2.000.000',
    },
    {
      stt: '10',
      name1: (
        <>
          <p>Quyền lợi Thai Sản :</p>
          <p>- Sinh thường</p>
          <p>- Biến chứng thai sản</p>
          <p>- Sinh mổ</p>
        </>
      ),
      name2: (
        <>
          <p>30.000.000/năm</p>
          <p>Theo giới hạn phụ 1 – Phần 2A</p>
          <p>Theo giới hạn phụ 1 và 2 - Phần 2A</p>
        </>
      ),
    },
  ];

  // UPDATED 2025-2026: Outpatient Treatment and Dental Care Table (Part 2B)
  const baoHiemNgoaiTruVaRang = [
    {
      stt: '',
      name1: 'Giới hạn Lãnh thổ',
      name2: 'Việt Nam',
    },
    {
      stt: '',
      name1: (
        <>
          <p>Giới hạn tối đa/Người/Năm</p>
          <p>(Giới hạn chung, bao gồm các giới hạn phụ dưới đây)</p>
        </>
      ),
      name2: '6.000.000',
    },
    {
      stt: '1',
      name1: (
        <>
          <p>Chi phí khám bệnh</p>
          <p>Chi phí thuốc theo kê đơn của bác sĩ</p>
          <p>Chi phí xét nghiệm, chẩn đoán hình ảnh và điều trị bệnh do bác sĩ chỉ định</p>
        </>
      ),
      name2: (
        <>
          <p>1.800.000/lần</p>
          <p>Không giới hạn số lần khám</p>
        </>
      ),
    },
    {
      stt: '2',
      name1: (
        <>
          <p>Điều trị bằng các phương pháp vật lý trị liệu do bác sỹ chỉ định</p>
        </>
      ),
      name2: (
        <>
          <p>600.000/năm</p>
        </>
      ),
    },
    {
      stt: '3',
      name1: (
        <>
          <p>Điều trị răng cơ bản</p>
          <p>- Khám, chụp X Quang răng</p>
          <p>- Lấy cao răng (2 lần/năm)</p>
          <p>- Nhổ răng bệnh lý (bao gồm tiểu phẫu, điều trị tủy răng)</p>
          <p>- Điều trị viêm nướu (lợi), nha chu</p>
          <p>- Trám (hàn) răng bằng các chất liệu thông thường (amalgam hoặc composite)</p>
        </>
      ),
      name2: (
        <>
          <p>1.800.000/năm</p>
        </>
      ),
    },
    {
      stt: '4',
      name1: (
        <>
          <p>Khám thai định kỳ</p>
        </>
      ),
      name2: (
        <>
          <p>600.000 VND/năm</p>
        </>
      ),
    },
  ];

  // UPDATED 2025-2026: Updated notes section with new requirements
  const luuYDieuTriRang = [
    '1. Đối với Quyền lợi điều trị răng:',
    '   + Tại Hà Nội và TP.HCM: Chi trả bồi thường khám chữa răng tại các bệnh viện công, các phòng nha/phòng khám và các phòng nha của các bệnh viện thuộc danh sách bảo lãnh viện phí của PVI',
    '   + Tỉnh/TP khác: Chi trả bồi thường khám chữa răng tại tất cả các phòng nha được cấp phép hợp pháp và có thể xuất hóa đơn GTGT theo quy định của Bộ Tài Chính và không thuộc Danh sách phòng nha bị loại trừ của PVI',
    '2. Đối với các bệnh viện, phòng khám, nhà thuốc từ chối chi trả của PVI: PVI sẽ không chi trả các chi phí y tế khi NĐBH khám và điều trị tại các bệnh viện, phòng khám, nhà thuốc nằm trong danh sách từ chối chi trả của Công ty Bảo Hiểm PVI',
    '3. Danh sách các bệnh viện, phòng khám trong danh sách bảo lãnh; danh sách các bệnh viện, phòng khám, nhà thuốc bị từ chối chi trả của PVI có thể thay đổi',
    '4. Đối với phòng khám tư: Toa thuốc phải có đầy đủ thông tin của phòng khám (tên phòng khám, địa chỉ phòng khám) và phải được đóng dấu mộc vuông của phòng khám tư. Trong trường hợp phòng khám tư không có con dấu vuông thì phải bổ sung giấy phép đăng ký mở phòng khám trong hồ sơ yêu cầu bồi thường',
  ];

  // UPDATED 2025-2026: Waiting period rules for health insurance coverage
  const thoiGianCho = [
    'Đối với thành viên cũ có tên trong hợp đồng bảo hiểm năm 2024 tham gia đủ từ 1 năm và vượt qua hết thời gian chờ: Miễn toàn bộ thời gian chờ, trong đó quyền lợi thai sản được bồi thường đầy đủ',
    'Đối với thành viên mới và thành viên cũ nhưng tham gia chưa đủ 1 năm và chưa qua hết thời gian chờ: Tiếp tục thời gian chờ tính từ ngày tham gia',
  ];

  // UPDATED 2025-2026: Waiting period table for employees
  const thoiGianChoNhanVien = [
    {
      name: 'Tai nạn', // UPDATED 2025-2026: Added accident coverage
      apply: 'Không áp dụng',
    },
    {
      name: 'Điều trị Bệnh thông thường,răng', // UPDATED 2025-2026: Combined general treatment and dental
      apply: 'Miễn chờ',
    },
    {
      name: 'Bồi thường theo tỷ lệ sảy thai/ hư thai/ Biến chứng thai sản',
      apply: '60 ngày',
    },
    {
      name: 'Bồi thường theo tỷ lệ sinh đẻ',
      apply: '270 ngày',
    },
    {
      name: 'Điều trị Bệnh đặc biệt, bệnh có sẵn, bệnh mãn tính',
      apply: 'Miễn chờ',
    },
    {
      name: 'Tử vong hoặc tàn tật toàn bộ vĩnh viễn do ốm bệnh thông thường',
      apply: '30 ngày',
    },
    {
      name: 'Tử vong hoặc tàn tật toàn bộ vĩnh viễn do thai sản',
      apply: '270 ngày',
    },
    {
      name: 'Tử vong hoặc tàn tật toàn bộ vĩnh viễn do Bệnh đặc biệt, bệnh có sẵn, bệnh mãn tính',
      apply: '365 ngày',
    },
  ];

  // UPDATED 2025-2026: Waiting period table for family members
  const thoiGianChoNguoiThan = [
    {
      name: 'Tai nạn', // UPDATED 2025-2026: Added accident coverage
      apply: 'Không áp dụng',
    },
    {
      name: 'Điều trị Bệnh thông thường',
      apply: '30 ngày',
    },
    {
      name: 'Bồi thường theo tỷ lệ sảy thai/ hư thai/ Biến chứng thai sản',
      apply: '60 ngày',
    },
    {
      name: 'Bồi thường sinh đẻ',
      apply: '270 ngày',
    },
    {
      name: 'Điều trị Bệnh đặc biệt, bệnh có sẵn, bệnh mãn tính',
      apply: '365 ngày',
    },
    {
      name: 'Tử vong hoặc tàn tật toàn bộ vĩnh viễn do ốm bệnh thông thường',
      apply: '30 ngày',
    },
    {
      name: 'Tử vong hoặc tàn tật toàn bộ vĩnh viễn do thai sản',
      apply: '270 ngày',
    },
    {
      name: 'Tử vong hoặc tàn tật toàn bộ vĩnh viễn do Bệnh đặc biệt, bệnh có sẵn, bệnh mãn tính',
      apply: '365 ngày',
    },
  ];

  const loaiTruDoiVoiBenh = [
    'Vitamin/ khoáng chất/ thực phẩm chức năng, các loại thuốc bổ sung cho chế độ dinh dưỡng, ăn kiêng bao gồm cả các sản phẩm làm đẹp.',
    'Điều trị các bệnh liên quan đến trở ngại về đường hô hấp: ngủ ngáy, ngừng thở khi ngủ',
    'Bất kỳ hình thức điều trị hoặc thuốc nào dựa vào thí nghiệm hoặc chưa được chứng minh dựa trên kiến thức y học được chấp nhận rộng rãi',
    'Điều dưỡng, an dưỡng',
    'Kiểm tra sức khỏe mà không liên quan đến điều trị bệnh tật.',
    'Điều trị hoặc phẫu thuật theo yêu cầu của Người được bảo hiểm và không liên quan đến việc điều trị và phẫu thuật bình thường do ngành y tế qui định',
    'Điều trị hoặc phẫu thuật các bệnh/ dị tật bẩm sinh hoặc di truyền',
    'Khám sức khoẻ định kỳ/ khám phụ khoa/ nam khoa/ chăm sóc trẻ sơ sinh/ tiêm chủng/ uống vắc xin phòng ngừa/ kiểm tra thị lực và thính lực thông thường/ điều trị suy thoái thị lực/ điều trị cận thị, viễn thị, loạn thị và những phẫu thuật sửa chữa những khiếm khuyết về suy thoái thị lực và thính lực tự nhiên',
    'Giải phẫu thẩm mỹ/ phẫu thuật tạo hình',
    'Chi phí phục hồi chức năng hoặc duy trì các bộ phận giả, răng giả',
    'Chăm sóc trước và sau khi sinh',
    'Kế hoạch hóa/ điều trị vô sinh, bất lực, rối loạn chức năng sinh dục, thụ tinh nhân tạo, liệu pháp thay đổi hóc môn, thay đổi giới tính',
    'Các bệnh lao, bệnh phong, sốt rét',
  ];

  const baoLanhVienPhi = [
    {
      name: 'NGƯỜI ĐƯỢC BH',
      list: ['Xuất trình thẻ PVI Care + CMND hoặc Giấy Khai Sinh nếu là trẻ con'],
    },
    {
      name: 'BỆNH VIỆN',
      list: ['Kiểm tra thẻ và gởi yêu cầu bồi thường cho PVI'],
    },
    {
      name: 'PVI',
      list: [
        'Kiểm tra thông tin NĐBH và xác nhận bảo lãnh viện phí',
        'Thanh toán trực tiếp cho bệnh viện',
      ],
    },
  ];

  // UPDATED 2025-2026: Updated hospital guarantee list with new information
  const benhVienBaoLanh = [
    {
      name: 'HÀ NỘI',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Bệnh viện Hữu Nghị - Khoa Khám chữa bệnh theo yêu cầu',
      address: 'Số 1, Trần Khánh Dư, Hai Bà Trưng',
      phone: '(0243) 972 4158',
      time: (
        <>
          <p>Thứ 2-6: 8h-17h</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Đại học Y Hà Nội',
      address: 'Số 1 Tôn Thất Tùng, Kim Liên',
      phone: '(024) 35747788',
      time: (
        <>
          <p>Thứ 2-6: 8h-17h</p>
        </>
      ),
    },
    {
      name: 'Phòng khám đa khoa Bệnh viện Đại học Y Hà Nội',
      address: 'Số 10 Trương Công Giai, Cầu Giấy',
      phone: '(024) 2324 0468',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Đại học Y Hà Nội - Cơ sở Hoàng Mai',
      address: 'Ngõ 587 Đường Tam Trinh, Yên Sở',
      phone: '19006422',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Áp dụng bảo lãnh từ ngày 1/04/2025</p>
        </>
      ),
    },
    {
      name: 'Phòng khám chuyên khoa Răng hàm mặt thuộc Viện Đào tạo Răng hàm mặt (Đại học Y Hà nội)',
      address: 'Nhà A7 - Số 1 - Tôn Thất Tùng, Đống Đa',
      phone: '(024) 3811 1777',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h30</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Bệnh Nhiệt Đới Trung ương - Khoa khám bệnh theo yêu cầu',
      address: 'Thôn Bầu, xã Thiên Lộc',
      phone: '(024) 3576 4305, Hotline: 0962 153 499',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h30</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Y Học Cổ Truyền Trung ương',
      address: '29 Nguyễn Bỉnh Khiêm, Hai Bà Trưng',
      phone: '(024) 38263616',
      time: (
        <>
          <p>Thứ 2-6: 7h30-16h30</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện đa khoa Xanh-pôn - Trung tâm kỹ thuật cao và Tiêu hóa',
      address: '12 Chu Văn An, Ba Đình',
      phone: '(024) 38233075, Hotline: 0989509115',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Không bảo lãnh chi phí thuốc trực tiếp</p>
        </>
      ),
    },
    {
      name: 'Bệnh Viện Nhi Trung ương - Trung tâm quốc tế',
      address: 'Số 18, ngõ 879, Đường La Thành, Láng',
      phone: '(024) 6273 8906',
      time: (
        <>
          <p>Thứ 2-6: 8h-11h30; 13h30-16h30</p>
        </>
      ),
    },
    {
      name: 'Bệnh Viện Bưu Điện',
      address: 'Số 49 phố Trần Điền, Phương Liệt',
      phone: '(024) 36402308',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Không bảo lãnh chi phí thuốc trực tiếp</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện HN Việt Đức - Khoa Điều trị theo yêu cầu IC',
      address: 'Số 8 Phủ Doãn, Hoàn Kiếm',
      phone: '(024) 3828 9402',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Không bảo lãnh chi phí thuốc trực tiếp</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Hữu Nghị Việt Đức',
      address: 'Số 40 Tràng Thị, Hoàn Kiếm',
      phone: '(024) 3717 0665, 1900 1902',
      time: (
        <>
          <p>Thứ 2-6: 8h-12h; 13h-15h30</p>
          <p>Không bảo lãnh chi phí thuốc trực tiếp</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Răng Hàm Mặt Trung ương Hà Nội',
      address: '40B Tràng Thi, Hoàn Kiếm',
      phone: '(024) 3828 5347',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h30</p>
          <p>Không bảo lãnh chi phí thuốc trực tiếp</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Nội Tiết Trung Ương cơ sở 1',
      address: 'Số 80 ngõ 82 Yên Lãng, Đống Đa',
      phone: '(024) 6288 5152',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>
            1. Bệnh viện chỉ xuất 1 hóa đơn cho tất cả chi phí điều trị (bảo lãnh và không bảo lãnh)
          </p>
          <p>2. Không bảo lãnh chi phí thuốc ngoại trú</p>
        </>
      ),
    },
    {
      name: 'HỒ CHÍ MINH',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Bệnh viện Đại học Y Dược TP HCM (*)',
      address: '215 Hồng Bàng, phường Chợ Lớn, TP. Hồ Chí Minh',
      phone: '028 3855 4269',
      time: (
        <>
          <p>T2-T6: 07h00-11h30; 13h00-16h30, T7: 07h00-11h30</p>
          <p>
            Áp dụng điều trị ngoại trú. Quy trình 3 bước: Đăng ký → Thanh toán → Xử lý PVI tại phòng
            BLVP của bệnh viện
          </p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Đại Học Y Dược - TP HCM cơ sở 2',
      address: '201 Nguyễn Chí Thanh, phường Chợ Lớn, TP. Hồ Chí Minh',
      phone: '028 38570757',
      time: (
        <>
          <p>T2-T6: 06h-11h00, 13h00-16h00, T7: 6h00-11h00</p>
          <p>
            Áp dụng chung. Loại trừ bảo lãnh PVI cho trường hợp đồng bảo hiểm/thai sản, nội trú có
            đồng bảo hiểm/thai sản, ngoại trú nếu thẻ bảo hiểm còn trong thời gian chờ
          </p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Đại Học Y Dược - TP HCM cơ sở 3 (*)',
      address: '221B Hoàng Văn Thụ, Phường Phú Nhuận, TP. Hồ Chí Minh',
      phone: '028 3844 2756',
      time: (
        <>
          <p>T2-T6: 07h-11h00, 13h00-16h00</p>
          <p>
            Áp dụng 1 trong 2 điều kiện. Loại trừ bảo lãnh PVI cho trường hợp đồng bảo hiểm/thai sản
            và ngoại trú nếu thẻ bảo hiểm còn trong thời gian chờ
          </p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Y Học Cổ Truyền (*)',
      address: '179 - 187 Nam Kỳ Khởi Nghĩa, phường Xuân Hòa, TP. Hồ Chí Minh',
      phone: '028 3932 6004',
      time: (
        <>
          <p>T2-T6: 07h00-11h00, 13h00-16h00</p>
          <p>
            Áp dụng 1 trong 2 điều kiện. Loại trừ bảo lãnh PVI cho trường hợp đồng bảo hiểm/thai sản
            và ngoại trú nếu thẻ bảo hiểm còn trong thời gian chờ
          </p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Tai Mũi Họng TP HCM (*)',
      address: '153 - 155 - 157 Trần Quốc Thảo, Phường Nhiêu Lộc, TP. Hồ Chí Minh',
      phone: '028 3931 7381',
      time: (
        <>
          <p>T2-T6: 07h30-10h00, 13h30-15h00</p>
          <p>
            Áp dụng 1 trong 2 điều kiện. Bảo lãnh ngoại trú không áp dụng cho yêu cầu dưới 1.500.000
            VND hoặc thẻ bảo hiểm trong thời gian chờ. Bảo lãnh nội trú không áp dụng nếu trách
            nhiệm khách hàng thấp hơn chi phí ước tính của bệnh viện. Loại trừ bảo lãnh PVI cho
            trường hợp đồng bảo hiểm
          </p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Từ Dũ - Nội trú (*)',
      address: '284 Cống Quỳnh, Phường Bến Thành, TP. Hồ Chí Minh',
      phone: '028 3839 5117',
      time: (
        <>
          <p>24/7</p>
          <p>
            Áp dụng 1 trong 2 điều kiện. Bảo lãnh PVI chỉ dành cho khách hàng nội trú sinh con hoặc
            chỉ định phẫu thuật
          </p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Từ Dũ - Ngoại trú (*)',
      address:
        'Phòng 101, lầu 1, Khu khám bệnh- Số 191 Nguyễn Thị Minh Khai, Phường Bến Thành, TP. Hồ Chí Minh',
      phone: '028 3839 5117',
      time: (
        <>
          <p>T2-T6: 07h00-10h30, 13h-15h30, T7: 07h00-10h00</p>
          <p>
            Áp dụng 1 trong 2 điều kiện. Loại trừ bảo lãnh PVI cho ngoại trú nếu thẻ bảo hiểm trong
            thời gian chờ hoặc trường hợp đồng bảo hiểm. Bảo lãnh PVI nội trú không áp dụng cho
            trường hợp đồng bảo hiểm
          </p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Mắt TP HCM (*)',
      address:
        'Khu khám mắt Khoa kỹ thuật cao - số 58 Bà Huyện Thanh Quan, Phường Xuân Hòa, TP. Hồ Chí Minh',
      phone: '028 3932 6732',
      time: (
        <>
          <p>T2-6: 7h00-10h30, 13h15-15h30</p>
          <p>
            Áp dụng 1 trong 2 điều kiện. Bệnh viện chưa mở lại dịch vụ bảo lãnh PVI do nâng cấp cơ
            sở vật chất
          </p>
        </>
      ),
    },
    // COMMENTED OUT: Remaining hospitals from old list - keeping for reference
    /*
    {
      name: 'Bệnh viện Nhi Đồng 2 (*)',
      address: '33 Nguyễn Du, Quận 1, HCM (Khoa khám bệnh tòa nhà mới)',
      phone: '028 3829 8385',
      time: (
        <>
          <p>T2-CN: 7h00-10h30, 13h00-15h30, 16h00-18h30</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Răng Hàm Mặt TP HCM (*)',
      address: '263-265 Trần Hưng Đạo, P. CG, Quận 1',
      phone: '028 3836 0191',
      time: (
        <>
          <p>T2-T6: 07h30 15h00</p>
          <p>T7: 07h30-10h00</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Hùng Vương',
      address:
        '128 Hồng Bảng, Phường 12, Quận 5, Tp Hồ Chí Minh * Địa điểm tiếp nhận thẻ PVI tại Khu A - Khoa sanh (Khu vực nhận sanh) và khoa cấp cứu.',
      phone: '028 3855 8532',
      time: (
        <>
          <p>24/7</p>
          <p>Đóng tạm ứng theo yêu cầu của BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Nhi đồng Thành phố (*)',
      address: (
        <>
          <p>Số 15 Đường Võ Trần Chi, Ấp 1, Xã Tân Kiên, Huyện Bình Chánh, TP. HCM.</p>
          <p>*Địa điểm tiếp nhận thẻ PVI tại Quầy thông tin của Bệnh viện</p>
        </>
      ),
      phone: '028 2253 6688',
      time: (
        <>
          <p>T2-6: 07h00 - 11h00, 13h00-16h00</p>
          <p>T7: 07h00-11h00</p>
          <p>Đóng tạm ứng ngoại trú: 500.000 đ/ lần khám. Tạm ứng nội trú theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Đa Khoa An Sinh (*)',
      address: 'Số 10 Trần Huy Liệu, Quận Phú Nhuận',
      phone: '028 3845 7777',
      time: (
        <>
          <p>T2-6: 07h30-10h, 13h30-15h</p>
          <p>T7:07h30-10h</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Phụ San Mê Kông',
      address: '243-243A-243B Hoàng Văn Thụ, Quận Tân Bình',
      phone: '028 3844 2986',
      time: (
        <>
          <p>24/7</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'HÀ NỘI',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Bệnh viện Hữu Nghị - Khoa Khám chữa bệnh theo Yêu cầu (*)',
      address: 'Số 1 Trần Khánh Dư, Hai Bà Trưng, Hà Nội',
      phone: '024 3822 1937',
      time: (
        <>
          <p>Thứ 2-6: 8h-17h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Đại học Y Hà Nội',
      address: 'Tòa nhà A2, Số 1 Tôn Thất Tùng, quận Đống Đa',
      phone: '024 3574 7788',
      time: (
        <>
          <p>Thứ 2-6: 8h-17h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Bệnh Nhiệt Đới Trung ương - Khoa khám bệnh theo yêu cầu (*)',
      address: 'Số 78 Đường Giải Phóng, quận Đống Đa',
      phone: '024 3576 5990',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h30</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Y Học Cổ Truyền Trung ương (*)',
      address: '29 Nguyễn Binh Khiêm, quận Hai Bà Trưng, Hà Nội',
      phone: '024 3826 3616',
      time: (
        <>
          <p>Thứ 2-6: 7h30h-16h30h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện đa khoa Xanh-pôn - Trung tâm kỹ thuật cao và Tiêu hóa (*)',
      address: '12 Chu Văn An, Điện Biên, Ba Đình, Hà Nội',
      phone: '024 3823 3075',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Giao thông vận tải Trung ương (*)',
      address: 'Ngõ 1194 Đường Láng, quận Đống Đa',
      phone: '024 3766 4751',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh Viện Nhi Trung ương - Khoa Quốc tế S (*)',
      address: '18/879 Đường Đê La Thành, quận Đống Đa',
      phone: '024 6273 1090',
      time: (
        <>
          <p>Thứ 2-6: 8h00-11h30; 13h30-16h30</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh Viện Bưu Điện (*)',
      address: 'Số 49 Trần Điền, quận Hoàng Mai',
      phone: '024 3640 2262',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện HN Việt Đức - Khoa Điều trị theo yêu cầu IC',
      address: 'Số 8 Phủ Doãn, quận Hoàn Kiếm',
      phone: '024 3828 9402',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Răng Hàm Mặt Trung ương Hà Nội (*)',
      address: '40 Tràng Thi, quận Hoàn Kiếm',
      phone: '024 3828 5347',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h30</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Nội Tiết Trung Ương (*)',
      address: 'Ngõ 215, đường Ngọc Hồi, thị trấn Văn Điển, Thanh Trì, Hà Nội',
      phone: '024 6288 5152',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Nội Tiết Trung Ương cơ sở 2 (*)',
      address: 'Khu B, Yên Lãng, Thái Thịnh, Đống Đa, Hà Nội',
      phone: '024 3853 3527',
      time: (
        <>
          <p>Thứ 2-6: 8h-16h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: (
        <>
          <p>Bệnh viện Phụ sản Hà Nội</p>
          <p>(Khu Điều trị Tự nguyện 1, Khu Điều trị Tự nguyện 2 và Khu B2)</p>
        </>
      ),
      address: 'Đường La Thành, Phường Ngọc Khánh, quận Ba Đình, Hà Nội',
      phone: '024 3775 1778',
      time: (
        <>
          <p>Thứ 2- 6: 8h-11h; 14h-16h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Đa khoa quốc tế Thu Cúc (*)',
      address: 'Số 286 Thụy Khuê, Tây Hồ, Hà Nội',
      phone: '024 3835 5555',
      time: (
        <>
          <p>Thứ 2-CN: 08h00-20h00</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Đa khoa Quốc tế Vinmec',
      address: '458 Minh Khai, Phường Vĩnh Tuy, Hai Bà Trưng, Hà Nội',
      phone: '024 3974 3556',
      time: (
        <>
          <p>Thứ 2-6: 08h00-17h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện đa khoa Hồng Ngọc cơ sở 1 (*)',
      address: '55 Yên Ninh, quận Ba Đình',
      phone: '024 7305 8880',
      time: (
        <>
          <p>Thứ 2-CN: 07h30-17h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện đa khoa Hồng Ngọc cơ sở 2 (*)',
      address: 'Khu B1 và Tầng 10, Keangnam Landmark 72, Phạm Hùng, Hà Nội',
      phone: '024 7305 8880',
      time: (
        <>
          <p>Thứ 2-CN: 07h30-17h</p>
          <p>Đóng tạm ứng theo yêu cầu BV</p>
        </>
      ),
    },
    {
      name: 'HẢI PHÒNG',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Bệnh viện Đại học Y Hải Phòng (*)',
      address: 'Số 225C Lạch Tray, Quận Ngô Quyền, Hải Phòng',
      phone: '0225 373 5696',
      time: (
        <>
          <p>Thứ 2-6: 7h30-16h30</p>
          <p>Đóng tạm ứng theo yêu cầu của BV</p>
        </>
      ),
    },
    {
      name: 'THÁI NGUYÊN',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Bệnh viện Đa Khoa Trung Ương Thái Nguyên (*)',
      address: '479 Lương Ngọc Quyến, Tp.Thái Nguyên, Tỉnh Thái Nguyên',
      phone: '0208 3851 348',
      time: (
        <>
          <p>Thứ 2-6: 7h-11h30, 13h30-17h</p>
          <p>Đóng tạm ứng theo yêu cầu của BV</p>
        </>
      ),
    },
    {
      name: 'THANH HÓA',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Bệnh viện Đa Khoa Tỉnh Thanh Hóa (*)',
      address: 'Số 181 Hải Thượng Làn Ông, phường Đông Vệ, thành phố Thanh Hóa, tỉnh Thanh Hóa',
      phone: '0237 3950 325',
      time: (
        <>
          <p>Thứ 2-6: 7h-11h30, 13h30-17h30</p>
          <p>Đóng tạm ứng theo yêu cầu của BV</p>
        </>
      ),
    },
    {
      name: (
        <>
          <p>Bệnh viện Đa Khoa Hợp Lực (*)</p>
          <p>
            <i style={{ color: 'red' }}>Dừng bảo lãnh từ ngày 07/02/2019</i>
          </p>
        </>
      ),
      address: '595 Nguyễn Chí Thanh, Đông Thọ, TP.Thanh Hóa',
      phone: '0237 3713 713',
      time: (
        <>
          <p>Thứ 2-7: 7h-11h30, 13h-16h30</p>
          <p>Đóng tạm ứng theo yêu cầu của BV</p>
        </>
      ),
    },
    {
      name: 'VINH',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Bệnh viện Quốc Tế Vinh (*)',
      address: 'Số 99 Phạm Đình Toái, thành phố Vinh, tỉnh Nghệ An',
      phone: '0238 860 6679',
      time: (
        <>
          <p>Thứ 2-7: 7h-12h00, 13h-16h00</p>
          <p>Đóng tạm ứng theo yêu cầu của BV</p>
        </>
      ),
    },
    {
      name: 'ĐÀ NẴNG',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Bệnh viện Đà Nẵng',
      address: '103 Quang Trung, TP Đà Nẵng',
      phone: '0236 3885 117',
      time: (
        <>
          <p>Thứ 2-6: 7h30-11h30, 13h30-17h00</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện ĐK Hoàn Mỹ Đà Nẵng (*)',
      address: '161 Nguyễn Văn Linh, quận Thanh Khê, TP Đà Nẵng',
      phone: '0236 3650 272',
      time: (
        <>
          <p>Thứ 2-7: 7h30-18h00</p>
          <p>Đóng tạm ứng theo yêu cầu của BV</p>
        </>
      ),
    },
    {
      name: 'Bệnh viện Tâm Trí Đà Nẵng (*)',
      address: '64 Cách Mạng Tháng Tám, P.Khuê Trung, Q.Cẩm Lệ, TP Đà Nẵng',
      phone: '0236 3679 555',
      time: (
        <>
          <p>Thứ 2-7: 7h-11h30, 12h30-16h</p>
        </>
      ),
    },
    {
      name: 'Trung tâm chuẩn đoán y khoa kỹ thuật cao Thiện Nhân - Đà Nẵng (*)',
      address: '112 Hoàng Đức Lương, Phường An Hải Bắc, Quận Sơn Trà, TP Đà Nẵng',
      phone: '0236 3828 489',
      time: (
        <>
          <p>Thứ 2-CN: 7h-11h30, 12h30-18h</p>
        </>
      ),
    },
    {
      name: 'HUẾ',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Trung tâm Điều trị theo yêu cầu và Quốc tế - Bệnh viện Trung ương Huế',
      address: '3 Ngô Quyền, Phường Vĩnh Ninh, Thành phố Huế',
      phone: '0234 3890 888',
      time: (
        <>
          <p>Thứ 2-7: 7h-17h00</p>
          <p>Đóng tạm ứng theo yêu cầu của BV</p>
        </>
      ),
    },
    {
      name: 'QUÃNG NGÃI',
      address: '',
      phone: '',
      time: '',
      isHeader: true,
    },
    {
      name: 'Nha Khoa Sài Gòn Quãng Ngãi (*)',
      address: '706 Quang Trung, P.Chánh Lộ, TP.Quãng Ngãi',
      phone: (
        <>
          <p>0255 383 7222</p>
          <p>0255 383 7799</p>
        </>
      ),
      time: (
        <>
          <p>Thứ 2-7: 7h00-19h00</p>
          <p>Chủ nhật: 7h300-17h00</p>
        </>
      ),
    },
    */
  ];

  // UPDATED 2025-2026: Updated rejected dental clinics list for Northern region
  const nhaKhoaTuChoiPhiaBac = [
    {
      name: 'Nha khoa Việt Hàn',
      address: '199A Lò Đúc, Phường Hai Bà Trưng, Hà Nội',
    },
    {
      name: 'Nha khoa Minh Tâm',
      address: '1B Trần Hưng Đạo, Phường Hai Bà Trưng, Hà Nội',
    },
    {
      name: 'Nha khoa Mỹ',
      address: '11 Cửa Nam, Phường Cửa Nam, Hà Nội',
    },
    {
      name: 'Nha khoa Việt Mỹ',
      address: '61 Trường Chinh, Phường Tương Mai, Hà Nội',
    },
    {
      name: 'Phòng khám răng hàm mặt Việt Xô',
      address: '108 Lương Thế Vinh, Phường Thanh Xuân, Hà Nội',
    },
    {
      name: 'Phòng khám CK Răng hàm mặt Trung Sơn (Tên cũ: Nha khoa Happy Smile Land)',
      address: '25A1 Trần Duy Hưng, Phường Yên Hòa, Hà Nội',
    },
    {
      name: 'Nha khoa Sài Gòn Hà Nội (Tên cũ: Nha khoa Sài Gòn)',
      address: '208 Trung Kinh, Phường Yên Hòa, Hà Nội',
    },
    {
      name: 'Nha khoa Osaka',
      address: 'VP3 bán đảo Linh Đàm Nguyễn Duy Trinh, Phường Linh Đàm, Hà Nội',
    },
    {
      name: 'Phòng khám nha khoa Sài Gòn Hà Nội (Tên cũ: Phòng khám nha khoa Sài Gòn)',
      address: '376 Trần Khát Chân, Phường Hai Bà Trưng, Hà Nội',
    },
    {
      name: 'Nha khoa Phạm Dương',
      address: 'Tầng 5, 52 Bà Triệu, Phường Cửa Nam, Hà Nội',
    },
    {
      name: 'Nha khoa quốc tế Nguyễn Khoa',
      address: 'Số 05 Nguyễn Du, Phường Nguyễn Du, Hà Nội',
    },
    {
      name: 'Nha khoa Nhật Tân',
      address: '525 Âu Cơ, Phường Phú Thượng, Hà Nội',
    },
    {
      name: 'Nha khoa 68',
      address: '30 Nguyễn Khuyến, Phường Văn Quân, Hà Nội',
    },
    {
      name: 'Nha khoa Smile One',
      address: '167 Phổ Quan Hoa, Phường Quan Hoa, Hà Nội',
    },
    {
      name: 'Nha khoa MISO',
      address: '291 Đường Nguyễn Khang, phường Cầu Giấy, Hà Nội',
    },
    {
      name: 'Nha khoa quốc tế Việt Hưng',
      address: 'Số 143 Sài Đồng, Phường Phúc Lợi, Hà Nội',
    },
    {
      name: 'Nha khoa Quốc tế Havi (HAN 365)',
      address: 'Số 365 Ngọc Lâm, phường Bồ Đề, Hà Nội',
    },
    {
      name: 'Nha khoa Tây Đô',
      address: 'số 22 lô A38 khu đô thị Geleximco Lê Trọng Tấn, xã An Khánh, Hà Nội',
    },
    {
      name: 'Nha khoa Việt Pháp',
      address: '459 Lê Duẩn, Phường Thanh Khê, Thành Phố Đà Nẵng',
    },
    {
      name: 'Nha Khoa Minh Ngọc - Beauty Dental Clinic',
      address: '617 Núi Thành, Phường Hòa Cường, Đà Nẵng',
    },
    {
      name: 'Nha khoa Việt Anh',
      address: 'Số 12 Triệu Nữ Vương, Phường Hải Châu, TP Đà Nẵng',
    },
    {
      name: 'Công ty TNHH Nha khoa Bông Sen Việt - Nha khoa Quốc tế Lotus Smile Detal Clinic',
      address: 'Số 104 Hoàng Hoa Thám, Phường Thanh Khê, TP Đà Nẵng',
    },
    {
      name: 'Nha khoa quốc tế Uông Bi',
      address: 'Tòa nhà Yên Thanh, tổ 7, khu 1, phường Uông Bí, tỉnh Quảng Ninh',
    },
    {
      name: 'Phòng khám nha khoa Nụ Cười Việt 2',
      address: '111A Mai Thúc Loan, Phường Phú Xuân, TP Huế',
    },
    {
      name: 'Công ty cổ phần Nha khoa Sing - Phòng khám nha khoa',
      address: 'Số 213 Hai Bà Trưng, Phường Phúc Yên, Tỉnh Phú Thọ',
    },
  ];

  // UPDATED 2025-2026: Commented out - No separate Southern dental clinics table in new data
  /*
  const nhaKhoaTuChoiPhiaNam = [
    {
      name: 'Nha khoa Pháp Việt - Bình Dương',
      address: '34 Đường Cách Mạng Tháng 8, Phường Chánh Nghĩa, TP Thủ Dầu Một, Bình Dương',
    },
    {
      name: 'Nha khoa Việt Mỹ',
      address: '526 Đại Lộ Bình Dương, Phường Hiệp Thành, TP Thủ Dầu Một, Bình Dương',
    },
    {
      name: 'Nha Khoa Nguyên Hùng',
      address: '175 Nguyễn thượng hiền F6 - Quận Bình thạnh DT 02862853799',
    },
    {
      name: 'Nha Khoa Smileland',
      address: '488 Liên Phường - Phước Long B - TP Thủ Đức - TPHCM',
    },
    {
      name: 'Nha Khoa Bảo Việt',
      address: '909A Huỳnh Tấn Phát, Khu phố 2, phường Phú Thuận, quận 7, Tp HCM',
    },
  ];
  */

  // UPDATED 2025-2026: Updated rejected hospitals/clinics list for Northern region
  const benhVienTuChoiPhiaBac = [
    {
      name: 'PK chuyên khoa Tai Mũi Họng',
      address: '375 Đường Giải Phóng, Phường Bạch Mai, Hà Nội (Địa chỉ cũ 367 Đường Giải Phóng)',
    },
    {
      name: 'PK chuyên khoa Tai Mũi Họng',
      address: 'Số 33/38 Phương Mai, Phường Lương Định Của, Hà Nội',
    },
    {
      name: 'PK Tai mũi họng chất lượng cao',
      address: '116 H2 Thành Công, Phường Thành Công, Hà Nội',
    },
    {
      name: 'Phòng khám chuyên khoa nội I.M.D (Tên cũ: PK YHCT Dasarang) (Công ty TNHH Dasarang Medical Việt Nam)',
      address: 'Tầng 2 khối A tòa nhà Sông Đà, số 18 đường Phạm Hùng, Phường Từ Liêm',
    },
    {
      name: 'Phòng khám YHCT Á Đông',
      address: '22D Giảng Võ, Phường Quốc Tử Giám, Hà Nội',
    },
  ];

  // UPDATED 2025-2026: Updated rejected hospitals/clinics list for Southern region
  const benhVienTuChoiPhiaNam = [
    {
      name: 'Phòng khám Đa khoa Hồng Cường',
      address: '87 - 89 Thành Thái, Phường Diên Hồng, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Phòng khám đa khoa Quốc Tế',
      address: '221 Nguyễn Thị Minh Khai, Phường Cầu Ông Lãnh, Thành phố Hồ Chí Minh',
    },
    {
      name: 'PK Đa Khoa Văn Kiệt',
      address: '646-648 Võ Văn kiệt, Phường Chợ Quán, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Phòng khám đa khoa Âu Á',
      address: '425 Nguyễn Văn Luông, Phường Phú Lâm, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Phòng khám đa khoa Thăng Long',
      address: '575 Sư Vạn Hạnh, Phường Hòa Hưng, Thành phố Hồ Chí Minh',
    },
    {
      name: 'PK Đa khoa Đinh Tiên Hoàng',
      address: '34 Đinh Tiên Hoàng, Phường Sài Gòn, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Phòng khám đa khoa Đại Đông',
      address: '461 Cộng Hòa, Phường Tân Bình, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Phòng khám đa khoa Hoàn Cầu',
      address: '80 đường Châu Văn Liêm, Phường Chợ Lớn, Thành phố Hồ Chí Minh',
    },
    {
      name: 'PK ĐK Nam Việt TPHCM',
      address: '202 Tô Hiến Thành, Phường Hòa Hưng, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Công ty TNHH Trung tâm y tế Hà Đô',
      address: 'Hiện đang tạm ngừng hoạt động',
    },
    {
      name: 'PK đa khoa Nguyễn Trãi Thủ Dầu Một',
      address: '303 đại lộ Bình Dương, Phường Chánh Nghĩa, Thành Phố Thủ Dầu Một, Tỉnh Bình Dương',
    },
    {
      name: 'Phòng khám đa khoa Cần Thơ (trước đây là Đa khoa Thế Kỷ Mới)',
      address: '133A Trần Hưng Đạo, Phường Cái Khế, TP Cần Thơ',
    },
    {
      name: 'Phòng khám đa khoa Nam Bộ',
      address: '134/1 Tô Hiến thành, Phường Hòa Hưng, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Phòng khám Nam khoa Đại Việt',
      address: '1505 đường 3 tháng 2, Phường Minh Phụng, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Phòng khám Đa Khoa Đại Tín',
      address: '306 Đại Lộ Bình Dương, Khu phố 1, Phường Phú Lợi, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Phòng khám đa khoa Đại Y',
      address: '274 Hải Thượng Lãn Ông, Phường Chợ Lớn, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Công Ty TNHH Lá Phong Quốc Tế (Maple Healthcare)',
      address: 'Tất cả các chi nhánh cơ sở',
    },
    {
      name: 'Phòng khám chuyên khoa YHCT (CÔNG TY TMHH DỊCH VỤ CHĂM SÓC SỨC KHỎE LÁ TRÀ)',
      address: 'Tất cả các chi nhánh/cơ sở',
    },
    {
      name: 'Phòng khám Đa Khoa Tháng Tám',
      address: '74 Cách Mạng Tháng Tám, Phường Xuân Hòa, Thành phố Hồ Chí Minh',
    },
  ];

  // UPDATED 2025-2026: Updated rejected pharmacies list
  const nhaThuocTuChoi = [
    {
      name: 'Nhà Thuốc Tân Bình 4',
      address: '498 Trường Chinh, Phường Tân Bình, Thành phố Hồ Chí Minh',
    },
    {
      name: 'Nhà Thuốc Mỹ Châu',
      address: 'Tất cả các chi nhánh/cơ sở',
    },
    {
      name: 'Nhà thuốc Maika',
      address: '95/471 Phạm Văn Thuận, Phường Tam Hiệp, Đồng Nai',
    },
    {
      name: 'Nhà thuốc Tây Hương Thảo (Hoàng Thị Kim Thanh)',
      address: '91 Phạm Ngũ Lão, khu phố Thắng Lợi 2, Phường Dĩ An, TP.HCM',
    },
  ];

  const chungTuBoiThuong = [
    {
      title: 'NẰM VIỆN NỘI TRÚ, ĐIỀU TRỊ TRONG NGÀY',
      list: [
        {
          name: 'Giấy yêu bồi thường của PVI, điền đầy đủ thông tin',
        },
        {
          name: 'Biên bản tường trình tai nạn (trong trường hợp tai nạn',
        },
        {
          name: 'Chỉ định và kết quả các xét nghiệm, chẩn đoán, chụp X-quang, chụp CT',
        },
        {
          name: 'Giấy chứng nhận phẫu thuật (nếu có)',
        },
        {
          name: 'Giấy chứng sinh hoặc Giấy khai sinh trong trường hợp sinh con',
        },
        {
          name: 'Giấy ra viện',
        },
        {
          name: 'Toa thuốc có chữ ký của bác sĩ',
        },
        {
          name: 'Hoá đơn VAT chi phí điều trị (bản gốc):',
        },
        {
          name: 'Hóa đơn VAT hoặc phiếu thu tiền thuốc (bản gốc)',
          list: [
            'Bảng kê chi tiết viện phí (Nếu trên hóa đơn không kê cụ thể các chi phí/ tên thuốc thì phải có bảng kê chi tiết đi kèm)',
          ],
        },
      ],
    },
    {
      title: 'ĐIỀU TRỊ NGOẠI TRÚ',
      list: [
        {
          name: 'Giấy yêu cầu bồi thường của PVI, điền đầy đủ thông tin',
        },
        {
          name: 'Biên bản tường trình tai nạn (trong trường hợp tai nạn)',
        },
        {
          name: 'Sổ khám bệnh/ toa thuốc có chuẩn đoán/ Giấy chứng nhận khám chữa bệnh',
        },
        {
          name: 'Chỉ định và kết quả các xét nghiệm, chẩn đoán, chụp X-quang, chụp CT',
        },
        {
          name: 'Trường hợp chữa tủy phải có hình chụp chân răng trước khi điều trị (*)',
        },
        {
          name: 'Toa Thuốc có chữ ký bác sĩ .',
        },
        {
          name: 'Hoá đơn VAT hoặc phiếu thu khám chữa bệnh (bản gốc)',
          list: [
            'Hóa đơn VAT hoặc phiếu thu tiền thuốc (bản gốc)',
            'Bảng kê chi tiết viện phí (Nếu trên hóa đơn không kê cụ thể các chi phí/ tên thuốc thì phải có bảng kê chi tiết đi kèm)',
          ],
        },
      ],
    },
    {
      title: 'HÓA ĐƠN VAT',
      list: [
        {
          name: 'Tổng giá trị thanh toán các phiếu thu ≤ 200,000 VNĐ => Hóa đơn VAT hoặc hóa đơn bán lẻ.',
        },
        {
          name: 'Tổng giá trị thanh toán các phiếu thu > 200,000 VNĐ => Bắt buộc phải có Hóa đơn VAT',
        },
      ],
    },
  ];

  const danhSachNhaThuocXuatHoaDonVAT = [
    {
      title: 'HÀ NỘI',
      list: [
        'Số 1 Phương Mai,Đống Đa',
        'Số 40 Phương Mai',
        '48 Hai Bà Trưng',
        'Ngự Bình,Lầu B ,Đống Đa',
        '625 Hoàng Hoa Thám',
        '33B Văn Miếu',
      ],
    },
    {
      title: 'HÀ NỘI',
      list: [
        'Số 20 Giải Phóng',
        'Số 229 Giải Phóng',
        'Số 69 Trần Xuân Soạn',
        'Số 102 Thái Thịnh',
        'Số 02 Hàng Bài',
        '46 Ngõ 164 Vương Thừa Vũ',
        'Số 3 Trần Hưng Đạo',
      ],
    },
    {
      title: 'ĐỒNG NAI',
      list: [
        '32A/4 QL 15, KP8, Tam Hiệp',
        '4 Đường 30/4,BV Đồng Nai',
        '221B QL15,Biên Hòa',
        '95/471 QL15, Biên Hòa',
        '77 Phan Đình Phùng',
      ],
    },
    {
      title: 'TP.HCM',
      list: [
        '243 Hai Bà Trưng,Q.1',
        '284 Cống Quỳnh, Q.1',
        '119 Lý Tự Trọng, Q.1',
        '202 Nguyễn Cư Trinh,Q.1',
        '389 Hai Bà Trưng,Q.3',
        '408 Hai Bà Trưng,Q.3',
        '410 Hai Bà Trưng,Q.3',
        '155B Trần Quốc Thảo, Q.3',
        '124 Trần Quốc Thảo,Q.3',
        '128 Trần Quốc Thảo,Q.3',
      ],
    },
    {
      title: 'TP.HCM',
      list: [
        '280 Điện Biên Phủ, Q.3',
        '338 Lê Văn Sỹ, Q.3',
        '02 Nguyễn Thông,Q.3',
        '510 Lê Văn Sỹ, Q.3',
        '929 Trần Hưng Đạo, Q.5',
        '615A Trần Hưng Đạo, Q.5',
        '201 Nguyễn Chí Thanh, Q.5',
        '27 Châu Văn Liêm, Q.5',
        '215 Hồng Bàng, Q.5',
        '334-336 Ngô Gia Tự,Q.10',
        '254 Hòa Hảo, Q.10',
      ],
    },
    {
      title: 'TP.HCM',
      list: [
        '520 Nguyễn Tri Phương,Q.10',
        '220/4 Ông Ích Khiêm,Q.10',
        '18-20 Nguyễn Trường Tộ,Q.4',
        '72 Bạch Đằng,Q.Bình Thạnh',
        '03 Nơ Trang Long,Q.Bình Thạnh',
        '01 Tô Ngọc Vân, Q.Thủ Đức',
        '4/10 Trần Văn Hứa,Q.Thủ Đức',
        '212 Lê Đức Thọ, Q.Gò Vấp',
        '11 Nguyễn Kiệm,Q.Gò Vấp ',
      ],
    },
  ];

  const thucPhamChucNang = [
    {
      name: 'THUỐC',
      number: (
        <>
          <p>V 1234-09</p>
          <p>VD 1234-10</p>
          <p>VN 1234-11</p>
        </>
      ),
      sign: (
        <>
          <p>Thuốc được đăng ký tại cục quản lý dược</p>
          <p>SĐK có chữ V, tiếp theo là số thứ tự & năm đăng ký</p>
        </>
      ),
    },
    {
      name: 'THỰC PHẨM CHỨC NĂNG',
      number: '1234/YT-CNTC',
      sign: 'Thực phẩm chức năng được đăng ký tại cục An toàn vệ sinh thực phẩm ,SĐK có chữ YT-CNTC (chứng nhận tiêu chuẩn)',
    },
    {
      name: 'MỸ PHẨM',
      number: (
        <>
          <p>1234/CBMP</p>
          <p>1234/LHMP</p>
          <p>1234/CBMP-HN</p>
        </>
      ),
      sign: 'Mỹ phẩm được đăng ký tại sở y tế địa phương có chữ CBMP. Công Bố Mỹ Phẩm hoặc LHMP: Liên Hiệp Mỹ Phẩm (HN: Hà Nội)',
    },
  ];

  const danhSachThacMac = [
    {
      question: '1) Thế nào là bệnh?',
      answer: {
        text: [
          'Ốm đau, bệnh tật: tình trạng sức khỏe bất thường so với tình trạng sức khỏe thông thường.',
        ],
      },
    },
    {
      question: '2) Những bệnh gì được xem là bệnh nghề nghiệp?',
      answer: {
        text: [
          'Bệnh nghề nghiệp được qui định bởi Luật lao động và Danh mục Bệnh nghề nghiệp được nêu ra trong Thông tư của Bộ Y Tế và Bộ Lao Động và Thương binh xã hội và Quyết định số 27/2006/QĐ-BYT ngày 21 tháng 9 năm 2006 của Bộ Y Tế bao gồm:',
        ],
        list: [
          'Nhiễm độc chì và các hợp chất chì',
          'Nhiễm độc Benzen và các đồng đẳng',
          'Nhiễm độc thủy ngân và các hợp chất thủy ngân',
          'Bụi phổi do Silic',
          'Bụi phổi do Amăng',
          'Nhiễm độc Mănggan và các hợp chất của Mănggan',
          'Nhiễm các tia phóng xạ và tia X',
          'Bệnh điếc nghề nghiệp do tiếng ồn',
          'Loét da, loét vách ngăn mũi, viêm da, chàm tiếp xúc',
          'Bệnh xạm da nghề nghiệp',
          'Bệnh bụi phổi bông',
          'Bệnh lap nghề nghiệp',
          'Bệnh viêm gan do Virut nghề nghiệp',
          'Bệnh nhiễm độc TNT (Trinitrotoluen)',
          'Bệnh nhiễm độc Asen và các hợp chất Asen nghề nghiệp',
          'Bệnh nhiễm độc Nicotin nghề nghiệp',
          'Bệnh nhiễm độc hóa chất trừ sâu nghề nghiệp',
          'Bệnh giảm áp mãn tính nghề nghiệp',
          'Bệnh viêm chế quản mạn tính nghề nghiệp',
          'Bệnh hen phế quản nghề nghiệp',
          'Bệnh nhiễm độc cacbonmonoxit nghề nghiệp',
          'Bệnh nốt dầu nghề nghiệp',
          'Bệnh viêm loét da, viêm móng, xung quanh móng nghề nghiệp',
        ],
      },
    },
    {
      question:
        '3) Bảo hiểm y tế và Bảo hiểm PVI Care khác nhau như thế nào? Có thể được yêu cầu bồi thường ở cả 2 nơi?',
      answer: {
        list: [
          'Tử vong/ thương tật vĩnh viễn: được bảo hiểm dưới bao nhiêu hợp đồng được bồi thường dưới bấy nhiêu hợp đồng;',
          'Chi phí y tế: Người được bảo hiểm có thể được bồi thường chi phí y tế từ một hoặc nhiều hợp đồng bảo hiểm khác nhau, nhưng số tiền được bồi thường không nhiều hơn tổng chi phí y tế đã bỏ ra (dựa trên chứng từ thanh toán hợp lý theo quy định tài chính)',
        ],
      },
    },
    {
      question:
        '4) Trong trường hợp cấp cứu, chi phí xe cứu thương để vận chuyển người được bảo hiểm đến bệnh viện có được bồi thường không? Nếu vận chuyển cấp cứu bằng những phương tiện khác thuận tiện hơn thì có được bồi thường không?',
      answer: {
        list: [
          'Vận chuyển cấp cứu sẽ được bồi thường theo quyền lợi của hợp đồng nếu hợp đồng có tham gia phần này và khi đấy là vận chuyển cấp cứu khẩn cấp hợp lý (phải nguy kịch đến tính mạng) đến phòng khám hoặc nơi điều trị gần nhất với chứng từ thanh toán hợp lệ.',
        ],
      },
    },
    {
      question: '5) Tôi nên khám ngoại trú ở đâu để được thanh toán?',
      answer: {
        text: [
          'Bạn được tự do lựa chọn nơi khám và điều trị phù hợp tại tất cả các cơ sở y tế có giấy phép hoạt động tại Việt Nam và có thể xuất hóa đơn tài chính cho anh chị đối với chi phí y tế trên VND 200,000.',
        ],
      },
    },
    {
      question: '6) Tôi có bị hạn chế số lần khám ngoại trú mỗi năm hay không?',
      answer: {
        text: ['Chương trình bảo hiểm của bạn không hạn chế số lần khám 1 năm.'],
      },
    },
    {
      question:
        '7) Tôi có thể được bồi thường khi đi khám, chữa tại bệnh viện Việt Pháp hay Comlumbia - Gia Định không?',
      answer: {
        text: [
          'Có, bạn sẽ được bồi thường khi đi khám, chữa bệnh ngoại trú hay nội trú tại hai bệnh viện này hoặc tất cả các bệnh viện khác có giấy phép hoạt động tại Việt Nam với điều kiện chi phí khám, chữa bệnh không vượt quá giới hạn quyền lợi bảo hiểm trên hợp đồng.',
          'Khi bạn đi khám chữa bệnh ở hai bệnh viện này, luôn nhớ yêu cầu nhân viên bệnh viện cung cấp các chứng từ sau để thực hiện thanh toán:',
        ],
        list: [
          'Chứng nhận bệnh lý có chữ kí của bác sĩ và dấu của bệnh viện (Medical Report/ Medical Certificate)',
          'Toa thuốc có chữ kí bác sĩ và dấu của bệnh viện',
          'Hóa đơn tài chính có dấu của bệnh viện, tên và chữ kí người thu tiền.',
          'Nếu hóa đơn thuốc chưa ghi rõ tên thuốc và liều lượng, vui lòng yêu cầu bệnh viện cung cấp OPD Charges (là một chứng từ thể hiện chi tiết thuốc đã mua)',
        ],
      },
    },
    {
      question:
        '8) Tôi có thể được bồi thường khi khám, chữa bệnh đông y hay khám, chữa bệnh tại phòng khám y khoa Trung Quốc?',
      answer: {
        list: [
          'Có, bạn sẽ được bồi thường khi đi khám chữa bệnh tại hai nơi này, với điều kiện chi phí khám, chữa bệnh không vượt quá giới hạn quyền lợi bảo hiểm trên hợp đồng',
          'Tất cả hóa đơn, chứng từ, toa thuốc, phải được thể hiện bằng tiếng Việt. Nếu hóa đơn, chứng từ bằng tiếng Hoa, hãy yêu cầu nơi khám chữa bệnh dịch sang tiếng Việt',
          'Nhà bảo hiểm khuyến cáo bạn nên khám chữa bệnh tại các Bệnh Viện/ Viện Y Học cổ truyền dân tộc. Những nơi có thể cung cấp dịch vụ khám chữa bệnh tốt và có đầy đủ chứng từ tôi yêu cầu.',
        ],
      },
    },
    {
      question: '9) Nếu bệnh cần điều trị dài hạn tôi sẽ gởi hồ sơ như thế nào?',
      answer: {
        text: [
          'Bạn có thể chờ điều trị xong sau đó thanh toán thành một lần tuy nhiên không vượt qua thời hạn bảo hiểm quy định nộp hồ sơ bồi thường là 180 ngày kể từ ngày hoàn tất việc điều trị. Lưu ý, bạn nên có giấy hẹn, chỉ định tái khám của bác sĩ cho những lần khám chữa kế tiếp.',
          'Nhằm giúp bạn theo dõi quá trình khám chữa bệnh của mình, bạn có thể giữ lại sổ khám bệnh gốc sau khi đã nộp cho nhà bảo hiểm bản photo có đóng dấu treo của công ty để xác nhận sao y bản chính.',
        ],
      },
    },
    {
      question: '10) Chi phí kiểm tra sức khỏe có được bồi thường không?',
      answer: {
        text: [
          'Không. Hợp đồng bảo hiểm sức khỏe chỉ bảo hiểm cho việc điều trị bệnh tật, ốm đau, thai sản.',
        ],
      },
    },
    {
      question:
        '11) Nếu tôi không thể đến bệnh viện hoặc các trung tâm y tế để khám bệnh được mà phải mời các bác sĩ đến nhà khám thì có được bồi thường không?',
      answer: {
        text: [
          'Không. Hợp đồng bảo hiểm không bảo hiểm cho việc điều trị tại nhà mà chỉ xem xét giải quyết cho việc điều trị tại các cơ sở y tế hoạt động hợp pháp.',
        ],
      },
    },
    {
      question: '12) Tôi có thể xin lại sổ khám bệnh/ giấy ra viện bản gốc?',
      answer: {
        text: [
          'Trong trường hợp cần thiết, Người được bảo hiểm có thể giữ lại bản gốc các chứng từ điều trị (toa thuốc, sổ khám bệnh, giấy ra viện,…) hoặc giấy nghỉ hưởng BHXH, chỉ cần gởi bản copy. Tuy nhiên, công ty bảo hiểm có thể yêu cầu cung cấp bản chính trong trường hợp cần thiết.',
        ],
      },
    },
    {
      question: '13) Trám răng thẩm mỹ có được bồi thường không?',
      answer: {
        text: [
          'Không. Chỉ có trám răng bằng amalgam hoặc composit mới được bồi thường theo quyền lợi chăm sóc răng cơ bản.',
        ],
      },
    },
    {
      question:
        '14) Nếu bác sĩ tư bán luôn thuốc và ghi tổng số tiền lên toa thuốc, tôi có được thanh toán không?',
      answer: {
        text: [
          'Theo quy định của pháp luật, bác sĩ Tây y không được phép bán thuốc nên toa thuốc do bác sĩ Tây y bán sẽ không được bảo hiểm chi trả. Ngược lại, bác sĩ Đông y được quyền bán thuốc với điều kiện xuất được hóa đơn hợp lệ.',
          'Còn tiền khám bệnh sẽ được Công ty bảo hiểm chi trả nếu bệnh đó thuộc phạm vi bảo hiểm của Hợp đồng bảo hiểm và khách cung cấp được hóa đơn hợp lệ.',
        ],
      },
    },
    {
      question:
        '15) Nếu tôi không có địa chỉ e-mail để liên hệ, tôi có thể sử dụng số điện thoại của tôi để liên hệ?',
      answer: {
        text: [
          'Địa chỉ e-mail cần phải có để chúng tôi liên hệ với bạn để gửi thông tin hoặc yêu cầu bổ sung đầy đủ thông tin, giấy tờ cần thiết, tránh bị thiếu sót & không đúng',
          'Bạn có thể sử dụng địa chỉ e-mail của bất kì ai mà bạn có thể mượn để sử dụng và cần ghi lưu ý trên giấy yêu cầu bồi thường là đề nghị chuyển thông tin đến bạn để bồi thường được biết.',
        ],
      },
    },
  ];

  return (
    <section>
      {showsScrolBtn && (
        <div
          id="scrolToTop"
          onClick={() => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            });
          }}
          style={{
            position: 'fixed',
            bottom: '60px',
            right: '60px',
            color: 'gray',
            textAlign: 'center',
            lineHeight: 0,
            textDecoration: 'none',
            borderRadius: '50%',
            backgroundColor: 'white',
            zIndex: '100',
          }}
        >
          <StyledButton />
        </div>
      )}

      <Container>
        <ContainerPink></ContainerPink>
        <ContainerPurple></ContainerPurple>
        <ContainerImg>
          <img src={BgrContainer} alt="background container" />
        </ContainerImg>
        <ContainerTitle>
          <Title>{t('PTIManagement:claim_insurance.title')}</Title>
          <SubTitle>{t('PTIManagement:claim_insurance.description')}​</SubTitle>
        </ContainerTitle>
      </Container>
      <Collapse
        accordion
        collapsible="header"
        style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}
      >
        <CustomPanel
          header={
            <div>
              <CollapseTitle>Quyền lợi bảo hiểm</CollapseTitle>
            </div>
          }
          key="1"
        >
          <Collapse
            accordion
            bordered={false}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          >
            <Panel
              header={<CollapseSmallTitle>Điều kiện tham gia bảo hiểm</CollapseSmallTitle>}
              key="1"
            >
              <div>
                {dieuKienThamGiaBH.map((ele: any) => {
                  return (
                    <div>
                      <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>{ele.title}</p>
                      <ul
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          paddingLeft: '30px',
                          gap: '10px',
                        }}
                      >
                        {ele.list.map((item: any) => {
                          return <li style={{ listStyle: 'disc', color: 'black' }}>{item.text}</li>;
                        })}
                      </ul>
                    </div>
                  );
                })}
              </div>
            </Panel>

            <Panel header={<CollapseSmallTitle>Các quyền lợi bảo hiểm</CollapseSmallTitle>} key="2">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {quyenLoiBaoHiem.map((ele: any) => {
                  return (
                    <div
                      style={{
                        width: '32%',
                        backgroundColor: '#B4C7E7',
                        borderRadius: '20px',
                        padding: '20px',
                      }}
                    >
                      <p
                        style={{
                          textAlign: 'center',
                          fontWeight: 'bold',
                          fontSize: '16px',
                          marginBottom: '10px',
                        }}
                      >
                        {ele.title}
                      </p>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '15px',
                          alignItems: 'center',
                        }}
                      >
                        {ele.list.map((item: any) => {
                          return (
                            <p
                              style={{
                                backgroundColor: '#396CC5',
                                color: 'white',
                                width: '70%',
                                borderRadius: '10px',
                                textAlign: 'center',
                                padding: '10px',
                              }}
                            >
                              {item.text}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Panel>

            <Panel header={<CollapseSmallTitle>Các loại trừ chung</CollapseSmallTitle>} key="3">
              <div>
                <ul
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: '30px',
                    gap: '10px',
                  }}
                >
                  {loaiTruChung.map((ele: any) => {
                    return <li style={{ listStyle: 'disc', color: 'black' }}>{ele}</li>;
                  })}
                </ul>

                <p style={{ fontWeight: 'bold', fontSize: '20px', textDecoration: 'underline' }}>
                  PHẦN 1 - BẢO HIỂM TAI NẠN
                </p>
                <p>
                  Bảo hiểm trường hợp tử vong, thương tật thân thể do tai nạn, trừ những trường hợp
                  loại trừ bảo hiểm theo quy tắc Bảo hiểm hiện hành
                </p>
                <SectionTable>
                  <table className="listHospital">
                    <tr>
                      <th style={{ width: '5%' }}>STT</th>
                      <th style={{ width: '45%' }}>QUYỀN LỢI BẢO HIỂM</th>
                      <th style={{ width: '25%', textAlign: 'center' }}>CƠ SỞ BỒI THƯỜNG</th>
                      <th style={{ width: '25%', textAlign: 'center' }}>
                        <p>SỐ TIỀN BẢO HIỂM (VNĐ)</p> <p>CHƯƠNG TRÌNH 1</p>
                      </th>
                    </tr>
                    {baoHiemTaiNan.map((item) => {
                      return (
                        <tr>
                          <td>{item.stt}</td>
                          <td>{item.name1}</td>
                          <td style={{ textAlign: 'center' }}>{item.name2}</td>
                          <td style={{ textAlign: 'center' }}>{item.name3}</td>
                        </tr>
                      );
                    })}
                  </table>
                </SectionTable>

                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    textDecoration: 'underline',
                    marginTop: '10px',
                  }}
                >
                  CÁC LOẠI TRỪ ĐỐI VỚI TỬ VONG DO BỆNH TẬT, THAI SẢN
                </p>

                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {loaiTruTuVongBenhVaThaiSan.map((ele) => {
                    return <li>{ele}</li>;
                  })}
                </ul>

                <p style={{ fontWeight: 'bold', fontSize: '20px', textDecoration: 'underline' }}>
                  PHẦN 2 - BẢO HIỂM TỬ VONG/ TÀN TẬT TOÀN BỘ VĨNH VIỄN DO ỐM ĐAU, BỆNH TẬT, THAI SẢN
                </p>
                <p>
                  Bảo hiểm trường hợp tử vong hoặc tàn tật toàn bộ vĩnh viễn do ốm đau, bệnh tật trừ
                  những điểm loại trừ bảo hiểm theo quy tắc BH hiện hành
                </p>
                <SectionTable>
                  <table className="listHospital">
                    <tr>
                      <th style={{ width: '5%' }}>STT</th>
                      <th style={{ width: '45%' }}>QUYỀN LỢI BẢO HIỂM</th>
                      <th style={{ width: '50%', textAlign: 'center' }}>
                        SỐ TIỀN BẢO HIỂM (VNĐ) CHƯƠNG TRÌNH 1
                      </th>
                      {/* <th style={{ width: '25%', textAlign: 'center' }}>CHƯƠNG TRÌNH 2</th> COMMENTED OUT: Only Program 1 available for 2025-2026 */}
                    </tr>
                    {baoHiemTuVong.map((item) => {
                      return (
                        <tr>
                          <td>{item.stt}</td>
                          <td>{item.name1}</td>
                          <td style={{ textAlign: 'center' }}>{item.name2}</td>
                          {/* <td style={{ textAlign: 'center' }}>{item.name3}</td> COMMENTED OUT: Only Program 1 available for 2025-2026 */}
                        </tr>
                      );
                    })}
                  </table>
                </SectionTable>

                <div style={{ paddingLeft: '20px' }}>
                  <p
                    style={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      textDecoration: 'underline',
                      marginTop: '10px',
                    }}
                  >
                    PHẦN 2A - BẢO HIỂM CHI PHÍ Y TẾ DO ỐM ĐAU, BỆNH TẬT THAI SẢN
                  </p>
                  <p>
                    Bảo hiểm trường hợp ốm đau, bệnh tật, thai sản phải nằm viện hoặc phẫu thuật,
                    trừ những trường hợp loại trừ bảo hiểm
                  </p>
                  <SectionTable>
                    <table className="listHospital">
                      <tr>
                        <th style={{ width: '5%' }}>STT</th>
                        <th style={{ width: '60%' }}>QUYỀN LỢI BẢO HIỂM</th>
                        <th style={{ width: '35%', textAlign: 'center' }}>
                          <p>SỐ TIỀN BẢO HIỂM (VNĐ) CHƯƠNG TRÌNH 1</p>
                        </th>
                      </tr>
                      {baoHiemChiPhiYTe.map((item) => {
                        return (
                          <tr>
                            <td>{item.stt}</td>
                            <td>{item.name1}</td>
                            <td style={{ textAlign: 'center' }}>{item.name2}</td>
                          </tr>
                        );
                      })}
                    </table>
                  </SectionTable>

                  <p
                    style={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      textDecoration: 'underline',
                      marginTop: '10px',
                    }}
                  >
                    PHẦN 2B - ĐIỀU TRỊ NGOẠI TRÚ VÀ CHĂM SÓC RĂNG
                  </p>

                  <SectionTable>
                    <table className="listHospital">
                      <tr>
                        <th style={{ width: '5%' }}>STT</th>
                        <th style={{ width: '45%' }}>QUYỀN LỢI BẢO HIỂM</th>
                        <th style={{ width: '50%', textAlign: 'center' }}>
                          <p>SỐ TIỀN BẢO HIỂM (VNĐ)</p> <p>CHƯƠNG TRÌNH 1</p>
                        </th>
                        {/* <th style={{ width: '25%', textAlign: 'center' }}>CHƯƠNG TRÌNH 2</th> COMMENTED OUT: Only Program 1 available for 2025-2026 */}
                      </tr>
                      {baoHiemNgoaiTruVaRang.map((item) => {
                        return (
                          <tr>
                            <td>{item.stt}</td>
                            <td>{item.name1}</td>
                            <td style={{ textAlign: 'center' }}>{item.name2}</td>
                            {/* <td style={{ textAlign: 'center' }}>{item.name3}</td> COMMENTED OUT: Only Program 1 available for 2025-2026 */}
                          </tr>
                        );
                      })}
                    </table>
                  </SectionTable>

                  <div style={{ marginTop: '20px' }}>
                    <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>Lưu ý: </p>
                    <ul
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        paddingLeft: '30PX',
                      }}
                    >
                      {luuYDieuTriRang.map((ele) => {
                        return <li>{ele}</li>;
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </Panel>

            <Panel header={<CollapseSmallTitle>Thời gian chờ</CollapseSmallTitle>} key="4">
              <ul
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  paddingLeft: '30px',
                }}
              >
                {thoiGianCho.map((ele: any) => {
                  return <li style={{ listStyle: 'disc', fontWeight: 'bold' }}>{ele}</li>;
                })}
              </ul>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <b style={{ fontSize: '16px' }}>Đối với Nhân viên</b>
                <SectionTable style={{ width: '100%' }}>
                  <table className="listHospital">
                    <tr>
                      <th style={{ width: '70%' }}>Tai nạn</th>
                      <th style={{ width: '30%', textAlign: 'center' }}>Không áp dụng</th>
                    </tr>
                    {thoiGianChoNhanVien.map((item) => {
                      return (
                        <tr>
                          <td>{item.name}</td>
                          <td style={{ textAlign: 'center' }}>{item.apply}</td>
                        </tr>
                      );
                    })}
                  </table>
                </SectionTable>

                <b style={{ fontSize: '16px', marginTop: '20px' }}>Đối với Người thân</b>
                <SectionTable style={{ width: '100%' }}>
                  <table className="listHospital">
                    <tr>
                      <th style={{ width: '70%' }}>Tai nạn</th>
                      <th style={{ width: '30%', textAlign: 'center' }}>Không áp dụng</th>
                    </tr>
                    {thoiGianChoNguoiThan.map((item) => {
                      return (
                        <tr>
                          <td>{item.name}</td>
                          <td style={{ textAlign: 'center' }}>{item.apply}</td>
                        </tr>
                      );
                    })}
                  </table>
                </SectionTable>
              </div>
            </Panel>

            <Panel header={<CollapseSmallTitle>Một số định nghĩa</CollapseSmallTitle>} key="5">
              <SectionSpecialDisease>
                <CardCustom title="Bệnh có sẵn">
                  <b>
                    <u>Bệnh có sẵn:</u>
                  </b>{' '}
                  là các bệnh có từ trước ngày bắt đầu tham gia bảo hiểm và do bệnh này,
                  <ul
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      paddingLeft: '30px',
                      gap: '10px',
                    }}
                  >
                    <li style={{ listStyle: 'disc' }}>
                      Người được bảo hiểm đã được điều trị trong vòng 3 năm trước ngày bắt đầu bảo
                      hiểm hoặc,
                    </li>
                    <li style={{ listStyle: 'disc' }}>
                      Có triệu chứng về mặt y khoa bất kể là người được bảo hiểm đã được khám, điều
                      trị hay chưa
                    </li>
                    <li style={{ listStyle: 'disc' }}>
                      Các bệnh sau: Viêm Amidan cần phải cắt, viêm VA cần phải nạo, vẹo vách ngăn
                      cần phẫu thuật, rối loạn tiền đình, thoái hóa khớp, đốt sống, viêm tai giữa
                      cần phẫu thuật, thoát vị đĩa đệm, bệnh hen.
                    </li>
                  </ul>
                </CardCustom>
                <CardCustom title="Bệnh đặc biệt">
                  <b>
                    <u>Bệnh đặc biệt:</u>
                  </b>{' '}
                  ung thư, u bướu các loại, huyết áp, tim mạch, loét dạ dày, viêm khớp mãn tính,
                  loét ruột, viêm gan, viêm màng trong dạ con, trĩ, sỏi các loại trong hệ thống tiết
                  niệu và đường mật, đục thủy tinh thể, viêm xoang, tiểu đường, Parkinson, bệnh liên
                  quan đến hệ thống tạo máu
                </CardCustom>
              </SectionSpecialDisease>
            </Panel>

            <Panel
              header={<CollapseSmallTitle>Một số loại trừ đối với bệnh</CollapseSmallTitle>}
              key="6"
            >
              <ul
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  paddingLeft: '30px',
                }}
              >
                {loaiTruDoiVoiBenh.map((ele) => {
                  return <li style={{ listStyle: 'disc' }}>{ele}</li>;
                })}
              </ul>
            </Panel>
          </Collapse>
        </CustomPanel>

        <CustomPanel
          header={
            <div>
              <CollapseTitle>Quy trình bồi thường</CollapseTitle>
            </div>
          }
          key="2"
        >
          <Collapse
            accordion
            bordered={false}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          >
            <Panel
              header={<CollapseSmallTitle>1. Hình thức bão lãnh trực tiếp</CollapseSmallTitle>}
              key="1"
            >
              <div>
                Hình thức bão lãnh trực tiếp (chỉ áp dụng bảo lãnh khi điều trị tại bệnh viện có
                trong danh sách bảo lãnh PVI):
              </div>
              <ul
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  paddingLeft: '30px',
                }}
              >
                <li style={{ listStyle: 'disc' }}>
                  Điều trị ở các bệnh viên có trong danh sách bảo lãnh của PVI
                </li>
                <li style={{ listStyle: 'disc' }}>Xuất trình CMND và thẻ bảo hiểm PVI</li>
              </ul>

              <div style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                Lưu ý : Không áp dụng bảo lãnh cho các trường hợp : tai nạn , cấp cứu, lễ tết và
                ngoài giờ hành chính
              </div>

              <p
                style={{
                  marginBottom: '10px',
                  marginTop: '30px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '20px',
                }}
              >
                BẢO LÃNH VIỆN PHÍ
              </p>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {baoLanhVienPhi.map((ele) => {
                  return (
                    <div style={{ width: '32%' }}>
                      <p
                        style={{
                          backgroundColor: '#4472C4',
                          color: 'white',
                          borderRadius: '5px',
                          padding: '10px',
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {ele.name}
                      </p>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '20px',
                          marginTop: '20px',
                          borderRadius: '5px',
                        }}
                      >
                        {ele.list.map((item) => {
                          return (
                            <p
                              style={{
                                backgroundColor: '#D3D9EC',
                                padding: '20px 10px',
                                textAlign: 'center',
                                borderRadius: '5px',
                              }}
                            >
                              {item}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              <p
                style={{
                  marginTop: '30px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '20px',
                }}
              >
                THẺ PVI CARE
              </p>
              <p
                style={{
                  marginBottom: '30px',
                  textAlign: 'center',
                }}
              >
                ( Được gửi vào địa chỉ email của mỗi cá nhân )
              </p>
              <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'center' }}>
                <img style={{ width: '500px' }} src={PVI_Insurance_card} alt="card PVI Insurance" />
              </div>

              <p
                style={{
                  marginTop: '30px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '20px',
                }}
              >
                DANH SÁCH BẢO LÃNH VIỆN PHÍ
              </p>
              <p style={{ color: 'red', fontWeight: 'bold' }}>
                -Để tham khảo thông tin chi tiết & đầy đủ được cập nhật liên tục kịp thời Danh sách
                bệnh viện bảo lãnh của PVI. Anh/Chị/Em vui lòng tham khảo tại link:{' '}
                <a
                  href="https://pvicare.vn/danh-sach-benh-vien"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'red' }}
                >
                  @https://pvicare.vn/danh-sach-benh-vien
                </a>
              </p>
              <SectionTable style={{ width: '100%' }}>
                <table className="listHospital">
                  {benhVienBaoLanh.map((item) => {
                    return (
                      <tr>
                        <td
                          style={
                            item.isHeader
                              ? {
                                  width: '25%',
                                  backgroundColor: '#FCD5B4',
                                  textAlign: 'center',
                                  fontWeight: 'bold',
                                }
                              : { width: '25%' }
                          }
                        >
                          {item.name}
                        </td>
                        <td
                          style={
                            item.isHeader
                              ? { width: '30%', backgroundColor: '#FCD5B4', textAlign: 'center' }
                              : { width: '30%' }
                          }
                        >
                          {item.address}
                        </td>
                        <td
                          style={
                            item.isHeader
                              ? { width: '15%', backgroundColor: '#FCD5B4', textAlign: 'center' }
                              : { width: '15%', textAlign: 'center' }
                          }
                        >
                          {item.phone}
                        </td>
                        <td
                          style={
                            item.isHeader
                              ? { width: '30%', backgroundColor: '#FCD5B4', textAlign: 'center' }
                              : { width: '30%', textAlign: 'center' }
                          }
                        >
                          {item.time}
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </SectionTable>

              <p style={{ marginTop: '30px', fontWeight: 'bold' }}>
                <i>(*) Lưu ý: PVI áp dụng chi trả cho điều trị răng như sau: </i>
              </p>
              <ul
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  paddingLeft: '30px',
                }}
              >
                <li style={{ listStyle: 'disc' }}>
                  Tại các khu vực: TP Hà Nội và TP Hồ Chí Minh: PVI chỉ chi trả cho khách hàng khi
                  khách hàng khám và điều trị nha khoa tại các cơ sở y tế Công lập và hoặc các cơ sở
                  y tế trong hệ thống bảo lãnh của PVI.
                </li>
                <li style={{ listStyle: 'disc' }}>
                  Đối với các địa bàn khác: Mở rộng chi trả tại các cơ sở y tế có giấy phép hoạt
                  động hợp pháp nhưng loại trừ các cơ sở y tế trong danh sách từ chối chi trả của BH
                  PVI.
                </li>
              </ul>

              <p style={{ marginTop: '30px', fontWeight: 'bold', textAlign: 'center' }}>
                DANH SÁCH NHA KHOA/NHÀ THUỐC/BỆNH VIỆN/PHÒNG KHÁM TỪ CHỐI CHI TRẢ
              </p>

              <div
                style={{
                  border: '1px solid #ddd',
                  textAlign: 'center',
                  padding: '5px 0',
                  fontWeight: 'bold',
                }}
              >
                Khu vực phía Bắc
              </div>
              <div
                style={{
                  border: '1px solid #ddd',
                  backgroundColor: '#02AEF8',
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                NHA KHOA
              </div>
              <SectionTable style={{ width: '100%', margin: '0' }}>
                <table className="listHospital">
                  <tr>
                    <th
                      style={{
                        width: '5%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      STT
                    </th>
                    <th
                      style={{
                        width: '40%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Tên
                    </th>
                    <th
                      style={{
                        width: '55%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Địa chỉ
                    </th>
                  </tr>

                  {nhaKhoaTuChoiPhiaBac.map((item, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.address}</td>
                      </tr>
                    );
                  })}
                </table>
              </SectionTable>

              {/* UPDATED 2025-2026: Commented out - No separate Southern dental clinics table in new data */}
              {/*
              <div
                style={{
                  border: '1px solid #ddd',
                  textAlign: 'center',
                  padding: '5px 0',
                  fontWeight: 'bold',
                }}
              >
                Khu vực phía Nam
              </div>
              <div
                style={{
                  border: '1px solid #ddd',
                  backgroundColor: '#02AEF8',
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                NHA KHOA
              </div>
              <SectionTable style={{ width: '100%', margin: '0' }}>
                <table className="listHospital">
                  <tr>
                    <th
                      style={{
                        width: '5%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      STT
                    </th>
                    <th
                      style={{
                        width: '40%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Tên
                    </th>
                    <th
                      style={{
                        width: '55%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Địa chỉ
                    </th>
                  </tr>

                  {nhaKhoaTuChoiPhiaNam.map((item, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.address}</td>
                      </tr>
                    );
                  })}
                </table>
              </SectionTable>
              */}

              <div
                style={{
                  border: '1px solid #ddd',
                  textAlign: 'center',
                  padding: '5px 0',
                  fontWeight: 'bold',
                }}
              >
                Khu vực phía Bắc
              </div>
              <div
                style={{
                  border: '1px solid #ddd',
                  backgroundColor: '#02AEF8',
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                BỆNH VIỆN/PHÒNG KHÁM
              </div>
              <SectionTable style={{ width: '100%', margin: '0' }}>
                <table className="listHospital">
                  <tr>
                    <th
                      style={{
                        width: '5%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      STT
                    </th>
                    <th
                      style={{
                        width: '40%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Tên
                    </th>
                    <th
                      style={{
                        width: '55%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Địa chỉ
                    </th>
                  </tr>

                  {benhVienTuChoiPhiaBac.map((item, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.address}</td>
                      </tr>
                    );
                  })}
                </table>
              </SectionTable>

              <div
                style={{
                  border: '1px solid #ddd',
                  textAlign: 'center',
                  padding: '5px 0',
                  fontWeight: 'bold',
                }}
              >
                Khu vực phía Nam
              </div>
              <div
                style={{
                  border: '1px solid #ddd',
                  backgroundColor: '#02AEF8',
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                BỆNH VIỆN/PHÒNG KHÁM
              </div>
              <SectionTable style={{ width: '100%', margin: '0' }}>
                <table className="listHospital">
                  <tr>
                    <th
                      style={{
                        width: '5%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      STT
                    </th>
                    <th
                      style={{
                        width: '40%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Tên
                    </th>
                    <th
                      style={{
                        width: '55%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Địa chỉ
                    </th>
                  </tr>

                  {benhVienTuChoiPhiaNam.map((item, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.address}</td>
                      </tr>
                    );
                  })}
                </table>
              </SectionTable>

              <div
                style={{
                  border: '1px solid #ddd',
                  backgroundColor: '#02AEF8',
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                NHÀ THUỐC
              </div>
              <SectionTable style={{ width: '100%', margin: '0' }}>
                <table className="listHospital">
                  <tr>
                    <th
                      style={{
                        width: '5%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      STT
                    </th>
                    <th
                      style={{
                        width: '40%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Tên
                    </th>
                    <th
                      style={{
                        width: '55%',
                        backgroundColor: '#D9E2F3',
                        padding: '0',
                        color: 'black',
                        textAlign: 'center',
                      }}
                    >
                      Địa chỉ
                    </th>
                  </tr>

                  {nhaThuocTuChoi.map((item, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.address}</td>
                      </tr>
                    );
                  })}
                </table>
              </SectionTable>
            </Panel>

            <Panel
              header={
                <CollapseSmallTitle>
                  2. Hình thức thanh toán trước, lấy hóa đơn về bồi thường sau
                </CollapseSmallTitle>
              }
              key="2"
            >
              <p>
                Hình thức thanh toán trước, lấy hóa đơn về bồi thường sau : ( Hình thức này áp dụng
                cho trường hợp khám ngoại trú và điều trị tại các bệnh viện nằm ngoài danh sách bảo
                lãnh PVI )
              </p>
              <ul
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  paddingLeft: '30px',
                  marginTop: '20px',
                }}
              >
                <li style={{ listStyle: 'disc' }}>
                  Các chứng từ cần thiết gửi yêu cầu bồi thường . Lưu ý : Hóa đơn cần nộp bản gốc -
                  Chứng từ y tế có thể nộp bản photo
                </li>
                <li style={{ listStyle: 'disc' }}>
                  Điền thông tin vào Giấy yều cầu trả tiền bảo hiểm:{' '}
                  <a href="/BM1C.04.GQKNN_Giayyeucautratienbaohiem_mẫu.doc" download>
                    BM1C.04.GQKNN_Giayyeucautratienbaohiem_mẫu.doc
                  </a>
                </li>
                <li style={{ listStyle: 'disc' }}>
                  Biên bản tường trình tai nạn (trường hợp bị tai nạn):{' '}
                  <a href="/BM1C.03.GQKN_Bienban-Bantuongtrinhtainan.doc" download>
                    BM1C.03.GQKN_Bienban-Bantuongtrinhtainan.doc
                  </a>
                </li>
                <li style={{ listStyle: 'disc' }}>
                  Thời hạn nộp hồ sơ bồi thường: trong vòng 60 ngày kể từ ngày kết thúc điều trị.
                  (nên nộp hồ sơ ngay hoặc không nên quá 7 - 10 ngày sau khi kết thúc điều trị).
                </li>
                <li style={{ listStyle: 'disc' }}>
                  Hóa đơn VAT phải được xuất trong vòng 30 ngày kể từ ngày mua hoặc sử dụng dịch vụ
                  (nên xuất hóa đơn ngay trong ngày kết thúc điều trị).
                </li>
                <li style={{ listStyle: 'disc' }}>
                  Danh sách nhà thuốc, phòng khám, nha khoa từ chối.
                </li>
              </ul>
              <p style={{ fontWeight: 'bold' }}>
                <i>
                  Lưu ý : sau khi gửi hồ sơ bồi thường đến trung tâm bồi thường, nhờ các anh chị lưu
                  lại bill, mã vận đơn của thư để khi cần kiểm tra có thể tra được thư từ bill hoặc
                  mã vận đơn của đơn vị chuyển phát nhanh
                </i>
              </p>

              <p
                style={{
                  fontWeight: 'bold',
                  textAlign: 'center',
                  fontSize: '20px',
                  marginTop: '30px',
                }}
              >
                CÁC CHỨNG TỪ BỒI THƯỜNG
              </p>

              {chungTuBoiThuong.map((ele) => {
                return (
                  <div>
                    <p
                      style={{ backgroundColor: '#DBDBDB', padding: '2px 5px', fontWeight: 'bold' }}
                    >
                      {ele.title}
                    </p>
                    <ul
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        paddingLeft: '30px',
                        marginTop: '20px',
                      }}
                    >
                      {ele.list.map((item) => {
                        return (
                          <>
                            <li style={{ listStyle: 'disc' }}>{item.name}</li>
                            {item.list?.map((text) => {
                              return <li>{text}</li>;
                            })}
                          </>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '24px',
                    textAlign: 'center',
                    marginTop: '30px',
                  }}
                >
                  MẪU KẾT QUẢ XÉT NGHIỆM
                </p>
                <img src={imagePVI} alt="img PVI" style={{ width: '750px' }} />
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '24px',
                    textAlign: 'center',
                    marginTop: '30px',
                  }}
                >
                  TOA THUỐC HÓA ĐƠN THUỐC
                </p>
                <img src={imagePVI1} alt="img PVI 1" style={{ width: '750px' }} />
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '24px',
                    textAlign: 'center',
                    marginTop: '30px',
                  }}
                >
                  HÓA ĐƠN DƯỚI 200.000 VNĐ
                </p>
                <img src={imagePVI2} alt="img PVI 2" style={{ width: '750px' }} />
                <p
                  style={{
                    fontWeight: 'bold',
                    fontSize: '24px',
                    textAlign: 'center',
                    marginTop: '30px',
                  }}
                >
                  HÓA ĐƠN TỪ 200.000 VNĐ TRỞ LÊN
                </p>
                <img src={imagePVI3} alt="img PVI 3" style={{ width: '750px' }} />
              </div>
            </Panel>

            <Panel
              header={<CollapseSmallTitle>3. Hướng dẫn nộp hồ sơ bồi thường</CollapseSmallTitle>}
              key="3"
            >
              <SectionGuarantee>
                <div className="wrapper_apply">
                  <div className="apply_left">
                    <div className="title">Hình thức nộp hồ sơ</div>
                    <ul
                      className="ul_list"
                      style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                    >
                      <li className="li_list">
                        <p>Có thể gửi qua app</p>
                        <ul>
                          <li>Đăng nhập vào app PVI</li>
                          <li>Làm theo hướng dẫn sử dụng app ở file hướng dẫn sử dụng app</li>
                          <div style={{ width: '100%', height: '100vh' }}>
                            <iframe
                              src={pdfUrl}
                              width="100%"
                              height="100%"
                              style={{ border: 'none' }}
                              title="PDF Viewer"
                            >
                              Trình duyệt của bạn không hỗ trợ hiển thị PDF. Bạn có thể tải xuống
                              file PDF <a href={pdfUrl}>tại đây</a>.
                            </iframe>
                          </div>
                        </ul>
                      </li>
                      {/* <li className="li_list">
                        <p>Hồ sơ YCBT Chi phí điều trị y tế (Hồ sơ ngoại trú – nha khoa):​</p>
                        <ul>
                          <li>
                            Hỗ trợ xuất hồ sơ qua:{' '}
                            <a href="https://itv.xclaim.vn/" target="_blank" rel="noreferrer">
                              https://itv.xclaim.vn/
                            </a>
                          </li>
                          <li>
                            Video hướng dẫn:{' '}
                            <a href="https://xclaim.vn/" target="_blank" rel="noreferrer">
                              https://xclaim.vn/
                            </a>
                          </li>
                        </ul>
                      </li> */}
                    </ul>
                  </div>
                  <div className="apply_right">
                    <p>
                      <b>
                        <u>Lưu ý</u>
                      </b>
                    </p>
                    <p style={{ marginBottom: '30px' }}>
                      Thời hạn nộp hồ sơ: <b>180 ngày</b> kể từ ngày điều trị cuối cùng.
                    </p>
                    <p>
                      Tuy nhiên, NĐBH nên nộp hồ sơ <b>trong vòng 30 ngày</b> kể từ ngày điều trị
                      cuối cùng để có thể dễ dàng bổ sung hồ sơ nếu được yêu cầu.
                    </p>
                  </div>
                </div>
              </SectionGuarantee>

              <p style={{ fontWeight: 'bold' }}>
                <i>
                  Lưu ý : Hình thức bồi thường qua app vẫn sẽ có 1 vài hồ sơ hoặc trường hợp đặc
                  biệt cần gửi hồ sơ bảng cứng cho PVI. Vậy nên nhờ các anh chị sau khi nộp qua app
                  vẫn giữ hồ sơ bệnh án bản cứng phòng trường hợp PVI yêu cầu gửi bảng cứng
                </i>
              </p>
              <p style={{ fontWeight: 'bold' }}>
                <i>
                  App PVI nếu tự động đăng xuất ra ngoài, hoặc có bất kì vấn đề gì về app, vui lòng
                  cập nhật ứng dụng và đăng nhập lại thử lần nữa.
                </i>
              </p>

              <p
                style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '24px',
                  marginTop: '30px',
                }}
              >
                DANH SÁCH CÁC NHÀ THUỐC CÓ THỂ XUẤT HÓA ĐƠN VAT
              </p>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  marginBottom: '70px',
                }}
              >
                {danhSachNhaThuocXuatHoaDonVAT.map((ele) => {
                  return (
                    <div style={{ width: '33%', border: '1px solid white' }}>
                      <p
                        style={{
                          backgroundColor: '#4472C4',
                          color: 'white',
                          textAlign: 'center',
                          fontSize: '20px',
                        }}
                      >
                        {ele.title}
                      </p>
                      <div
                        style={{ backgroundColor: '#CFD5EA', height: '100%', paddingLeft: '5px' }}
                      >
                        {ele.list.map((item) => {
                          return <p>{item}</p>;
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              <p
                style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '24px',
                }}
              >
                CÁCH NHẬN BIẾT THUỐC, MỸ PHẨM, THỰC PHẨM CHỨC NĂNG
              </p>

              <SectionTable style={{ width: '100%', margin: '0' }}>
                <table className="listHospital">
                  <tr>
                    <th
                      style={{
                        width: '30%',
                        backgroundColor: '#4472C4',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      SẢN PHẨM
                    </th>
                    <th
                      style={{
                        width: '20%',
                        backgroundColor: '#4472C4',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      SỐ ĐĂNG KÝ
                    </th>
                    <th
                      style={{
                        width: '50%',
                        backgroundColor: '#4472C4',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      DẤU HIỆU NHẬN BIẾT
                    </th>
                  </tr>

                  {thucPhamChucNang.map((item) => {
                    return (
                      <tr>
                        <td>{item.name}</td>
                        <td>{item.number}</td>
                        <td>{item.sign}</td>
                      </tr>
                    );
                  })}
                </table>
              </SectionTable>
            </Panel>
          </Collapse>
        </CustomPanel>

        <CustomPanel
          header={
            <div>
              <CollapseTitle>Thông tin chung về công ty bảo hiểm PVI</CollapseTitle>
            </div>
          }
          key="3"
        >
          <Collapse
            accordion
            bordered={false}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          >
            <Panel header={<CollapseSmallTitle>Hotline</CollapseSmallTitle>} key="1">
              <div style={{ paddingLeft: '30px' }}>
                <ul style={{ margin: '0' }}>
                  <li style={{ listStyle: 'disc' }}>
                    <b>NGUYỄN THỊ MỸ TUYÊN</b>
                  </li>
                </ul>
                <p>
                  <b>CÔNG TY BẢO HIỂM PVI GIA ĐỊNH</b>
                </p>
                <ul style={{ marginTop: '30px', marginBottom: '0' }}>
                  <li style={{ listStyle: 'disc' }}>
                    <b>Address:</b> Tầng 3, Cao Ốc Yoco, 41 Nguyễn Thị Minh Khai, Phường Bến Nghé,
                    Quận 1, Tp.HCM
                  </li>
                </ul>
                <p>
                  <b>Phone :</b> 0938 796 388
                </p>
                <p>
                  <b>E-mail :</b> tuyenntm@pvi.com.vn
                </p>
              </div>
            </Panel>
            <Panel
              header={<CollapseSmallTitle>Thông tin gửi hồ sơ bồi thường</CollapseSmallTitle>}
              key="2"
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <p>
                  <b>VP Phía Bắc:</b>
                </p>
                <p>
                  Người Nhận : Phòng chi trả trực tiếp - Văn phòng đại diện CSKH phía Bắc bảo hiểm
                  PVI
                </p>
                <p>
                  Địa chỉ : Tầng 19 Tòa nhà PVI Tower, số 1 Phạm Văn Bạch, phường Yên Hòa, quận Cầu
                  Giấy, thành phố Hà Nội
                </p>
                <p>Điện thoại: (024) 3768 2999 Fax: (024) 3795 5625</p>
              </div>
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '30px' }}
              >
                <p>
                  <b>VP Phía Nam:</b>
                </p>
                <p>
                  Người Nhận : Phòng chi trả trực tiếp - Văn phòng đại diện CSKH phía Nam bảo hiểm
                  PVI
                </p>
                <p>
                  Địa chỉ : Tầng 1 tòa nhà PV Gas, 673 Nguyễn Hữu Thọ, huyện Nhà Bè, thành phố Hồ
                  Chí Minh
                </p>
                <p>Điện thoại: (028) 6290.9118 - Fax: (028) 6290.9108</p>
              </div>
            </Panel>
            <Panel header={<CollapseSmallTitle>Giải đáp thắc mắc</CollapseSmallTitle>} key="3">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {danhSachThacMac.map((ele) => {
                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>{ele.question}</p>
                      {ele.answer?.text &&
                        ele.answer.text.map((item) => {
                          return <p>{item}</p>;
                        })}
                      {ele.answer?.list && (
                        <ul
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            paddingLeft: '30px',
                          }}
                        >
                          {ele.answer.list.map((item) => {
                            return <li style={{ listStyle: 'disc' }}>{item}</li>;
                          })}
                        </ul>
                      )}
                    </div>
                  );
                })}
              </div>
            </Panel>
          </Collapse>
        </CustomPanel>
      </Collapse>
      {/* </Space> */}
    </section>
  );
};

export default PageXclaimInsurance;

export const CustomButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
`;
export const StyledButton = styled(UpCircleOutlined)`
  font-size: 40px;
  color: var(--cl_info500);
  cursor: pointer;
`;
export const CustomPanel = styled(Collapse.Panel)`
  .ant-collapse-header {
    background-color: #f3f2f2;
  }
  .ant-collapse {
    font-size: 16px;
  }
  p {
    margin: 0;
  }
`;
export const Container = styled.div`
  margin: 15px 0;
  width: 100%;
  height: 300px;
  position: relative;
  p {
    margin: 0;
  }
`;
export const ContainerPink = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 92%;
  height: 85%;
  background-color: #f85982;
`;
export const ContainerPurple = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 92%;
  height: 85%;
  margin: 0 0 20px 40px;
  background-color: #7d35b3;
`;
export const ContainerImg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 92%;
  height: 85%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;
export const ContainerTitle = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 500px;
  height: 200px;
  background-color: white;
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
`;
export const Title = styled.div`
  font-size: 35px;
  font-weight: bold;
`;
export const SubTitle = styled.div`
  font-size: 18px;
  color: #774774;
`;
export const CollapseTitle = styled.div`
  font-size: 24px;
  color: black;
  font-weight: bold;
`;
export const CollapseSmallTitle = styled.div`
  font-size: 18px;
  color: black;
`;

export const SectionTable = styled.div`
  margin-top: 20px;
  p {
    margin: 0;
  }
  .title_section {
    font-size: 32px;
    color: black;
    font-weight: bold;
  }
  .text_section {
    font-size: 18px;
    color: black;
  }
  .listHospital {
    font-family: Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  .listHospital td,
  .listHospital th {
    border: 1px solid #ddd;
    padding: 8px;
  }

  .listHospital tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  .listHospital tr:hover {
    background-color: #ddd;
  }

  .listHospital th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #48086f;
    color: white;
  }
`;

export const SectionSpecialDisease = styled.div`
  margin-top: 20px;
  p {
    margin: 0;
  }
  .title_section {
    font-size: 32px;
    color: black;
    font-weight: bold;
  }
`;

export const CardCustom = styled(Card)`
  .ant-card-head {
    background-color: #48086f;
    font-size: 22px;
    color: white;
    border-radius: 10px;
  }
  .ant-card-body {
    font-size: 18px;
  }
`;

export const SectionGuarantee = styled.div`
  margin-top: 20px;
  p {
    margin: 0;
  }
  .title_section {
    font-size: 32px;
    color: black;
    font-weight: bold;
  }
  .subTitle_section {
    font-size: 20px;
    color: black;
  }
  .wrapper_guarantee {
    .guarantee_card {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 50px;
      .guarantee_card_box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img {
          width: 100px;
          height: 100px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          color: #006fc0;
          font-size: 18px;
        }
      }
      .add {
        font-size: 30px;
        color: #006fc0;
      }
    }
    .guarantee_steps {
      color: black;
      font-size: 18px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .guarantee_steps_left {
        width: 50%;
      }
      .guarantee_steps_right {
        width: 45%;
        border: 2px solid red;
        div {
          font-weight: bold;
          text-align: center;
        }
      }
    }
  }
  .wrapper_recoup {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
    .recoup_box {
      display: flex;
      gap: 30px;
      .img {
        width: 70px;
        height: 70px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        font-size: 18px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        p:first-child {
          font-weight: bold;
        }
      }
    }
  }
  .wrapper_day {
    margin: 20px 0 150px 0;
    display: flex;
    flex-wrap: wrap;
    column-gap: 50px;
    row-gap: 150px;
    .day_box {
      font-size: 18px;
      width: 150px;
      height: 100px;
      padding: 10px;
      color: white;
      border-radius: 10px;
      position: relative;
      .box_bottom {
        position: absolute;
        bottom: -120%;
        left: 20%;
        background-color: white;
        border-radius: 10px;
        height: 150px;
        width: 150px;
        padding: 10px;
      }
    }
    .img_right {
      width: 50px;
      height: 50px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .note {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    p:first-child {
      color: #3adcc9;
    }
  }
  .wrapper_prepayment {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .prepayment_left {
      width: 32%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 50px;
    }
    .prepayment_center {
      width: 32%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .prepayment_right {
      width: 32%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 50px;
    }
    .prepayment_box {
      border-radius: 10px;
      .title {
        color: white;
        font-size: 20px;
        padding: 15px;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        text-align: center;
      }
      .list {
        font-size: 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 10px;
      }
    }
  }
  .total_pay {
    margin-top: 40px;
    .total {
      display: flex;
      flex-direction: column;
      align-items: center;
      .total_top {
        display: flex;
        width: 100%;
        .total_box {
          background-color: #e6e6e6;
          font-size: 18px;
          width: 34%;
          height: 70px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 10px;
        }
      }
    }
    .note {
      margin-top: 20px;
      font-weight: normal;
      .title {
        color: black;
        font-weight: bold;
        font-size: 18px;
      }
      ul {
        padding-left: 50px;
        margin: 0;
        li {
          list-style-type: disc;
        }
      }
      .warning {
        color: red;
      }
    }
  }
  .wrapper_apply {
    padding: 10px 40px;
    border: 4px solid #48086f;
    display: flex;
    justify-content: space-between;
    border-radius: 50px;
    margin-bottom: 20px;
    .apply_left {
      width: 60%;
      .title {
        font-size: 20px;
        color: #48086f;
        text-align: center;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .ul_list {
        margin: 0;
        .li_list {
          list-style-type: disclosure-closed;
          color: #48086f;
          font-size: 18px;
          font-weight: bold;
          ul {
            padding-left: 40px;
            li {
              list-style-type: disc;
              color: black;
              font-weight: normal;
            }
          }
        }
      }
    }
    .apply_right {
      width: 35%;
      border: 3px solid black;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .wrapper_note {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 20px;
    .note_box {
      border: 1px solid black;
      border-radius: 10px;
      width: 45%;
      padding: 15px;
      .top {
        height: 50px;
        display: flex;
        justify-content: space-between;
        .left {
          width: 70%;
          font-size: 26px;
          font-weight: bold;
        }
        .right {
          width: 30%;
          display: flex;
          justify-content: flex-end;
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
        }
      }
      .bottom {
        .title {
          font-size: 26px;
          font-weight: bold;
        }
        .text {
          font-size: 18px;
        }
      }
    }
  }
  .wrapper_bill {
    display: flex;
    justify-content: space-between;
    .left {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 18px;
        background-color: #d8d7df;
        padding: 5px 10px;
      }
      div {
        width: 300px;
        height: 450px;
        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }
    }
    .right {
      width: 30%;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .box {
        background-color: #d8f8f4;
        padding: 10px;
        p {
          font-weight: bold;
        }
        ul {
          margin: 0;
          padding-left: 50px;
          li {
            list-style-type: square;
          }
        }
      }
    }
  }
`;
